/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import useSwr from 'swr';
import type { Arguments, Key, SWRConfiguration } from 'swr';

import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';

import type {
    BodyUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost,
    BodyUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost,
    DeviceIdentity,
    DeviceIdsStart,
    DeviceIdsStop,
    DownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet424,
    DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet404,
    DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet424,
    ErrorBadCfgResponse,
    ErrorBadStatusResponse,
    ErrorDependencyFailure,
    ErrorDeviceNotFound,
    ErrorInvalidFilename,
    ErrorInvalidHeader,
    ErrorNotSupportedInMode,
    GetDeviceBaselineDevicesDeviceIdBaselineGet404,
    GetDeviceBaselineDevicesDeviceIdBaselineGet424,
    GetDeviceCfgDevicesDeviceIdConfigGet200,
    GetDeviceCfgDevicesDeviceIdConfigGet404,
    GetDeviceDevicesDeviceIdGet200,
    GetDeviceStatusDevicesDeviceIdStatusGet200,
    GetDeviceStatusDevicesDeviceIdStatusGet404,
    GetIotEventHistoryIotIdEventsHistoryGetParams,
    GetIotEventsIotIdEventsRecentGetParams,
    HTTPValidationError,
    IotDacSetPayload,
    IotPinBindingPayload,
    IotRelayOffIotIdRelayPinRefOffPostParams,
    IotRelayOnIotIdRelayPinRefOnPostParams,
    IotRelaysOnIotIdRelaysOnPostParams,
    IotSelectedPinsPayload,
    LayoutMap,
    ListBaselineFilesDevicesDeviceIdBaselineListGet404,
    ListBaselineFilesDevicesDeviceIdBaselineListGet424,
    ListDevicesDevicesGetParams,
    ListSweepArchivesDevicesDeviceIdArchiveModeListGet404,
    ListSweepArchivesDevicesDeviceIdArchiveModeListGet424,
    LiveSubscribeDevicesDeviceIdLiveSubscribePostParams,
    LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostParams,
    OtaPushAllOtaPushPostParams,
    ResponseBaseline,
    ResponseDeviceRegistryMap,
    ResponseFileList,
    SDRConfigParams,
    SaveStartAllDevicesAllSaveStartPostParams,
    SaveStartDevicesDeviceIdSaveStartPostParams,
    SdrLiveStartDevicesDeviceIdLiveStartPostParams,
    SdrLiveStopDevicesDeviceIdLiveStopPostParams,
    UpdateDeviceCfgDevicesDeviceIdConfigPatchParams,
    UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostParams,
    UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostParams,
} from './model';

import listDevicesDevicesGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getDeviceDevicesDeviceIdGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getDeviceStatusDevicesDeviceIdStatusGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getDeviceCfgDevicesDeviceIdConfigGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import updateDeviceCfgDevicesDeviceIdConfigPatchMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getDeviceBaselineDevicesDeviceIdBaselineGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import listBaselineFilesDevicesDeviceIdBaselineListGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import listSweepArchivesDevicesDeviceIdArchiveModeListGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import switchDeviceModeDevicesDeviceIdModeModePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import baselineStartDevicesBaselineStartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import baselineStopDevicesBaselineStopPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import sdrLiveStartDevicesDeviceIdLiveStartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import sdrLiveStopDevicesDeviceIdLiveStopPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import liveSubscribeDevicesDeviceIdLiveSubscribePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import liveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import engineStartAllDevicesAllStartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import engineStopAllDevicesAllStopPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import engineStartDevicesDeviceIdStartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import engineStopDevicesDeviceIdStopPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import saveStartAllDevicesAllSaveStartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import saveStopAllDevicesAllSaveStopPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import saveStartDevicesDeviceIdSaveStartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import saveStopDevicesDeviceIdSaveStopPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import restartAllDevicesDevicesAllRestartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import restartDeviceDevicesDeviceIdRestartPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import setDeviceIdentityDevicesDeviceIdSetIdentityPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getIotIotGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getIotEventsIotIdEventsRecentGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getIotEventHistoryIotIdEventsHistoryGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getIotDescriptorIotIdDescriptorGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getIotBindingsIotBindingsGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getIotDacStateIotIdDacPinRefGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import setIotDacValueIotIdDacPinRefPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import zeroIotDacIotIdDacZeroPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import iotRelaysOnIotIdRelaysOnPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import iotRelayOnIotIdRelayPinRefOnPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import iotRelayOffIotIdRelayPinRefOffPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import saveIotBindingIotBindingsIdPinIdPutMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import removeIotBindingIotBindingsIdPinIdDeleteMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getLayoutMapLayoutGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import saveLayoutMapLayoutPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getLatestFirmwareOtaLatestGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import otaPushAllOtaPushPostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import manifestCompensationAntennasManifestGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import antennaJsonCompensationAntennasDataAntennaIdJsonGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import antennaBinCompensationAntennasDataAntennaIdBinGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import getDeviceAntennasCompensationDeviceIdAntennasGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import enableVswrCompensationCompensationDeviceIdVswrEnablePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import disableVswrCompensationCompensationDeviceIdVswrDisablePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import enableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import disableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import downloadMeasurementReportSummaryDocumentsDownloadSummaryGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import listMeasurementReportsDocumentsMeasurementReportsListGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
import uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutator from '../cloak-auth/src/Client/OrvalGnssFetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get list of connected devices
 * @summary List devices
 */
export const getListDevicesDevicesGetUrl = (params?: ListDevicesDevicesGetParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/devices?${stringifiedParams}` : `/devices`;
};

export const listDevicesDevicesGet = async (
    params?: ListDevicesDevicesGetParams,
    options?: RequestInit,
): Promise<ResponseDeviceRegistryMap> => {
    return listDevicesDevicesGetMutator<ResponseDeviceRegistryMap>(getListDevicesDevicesGetUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getListDevicesDevicesGetKey = (params?: ListDevicesDevicesGetParams) =>
    [`/devices`, ...(params ? [params] : [])] as const;

export type ListDevicesDevicesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listDevicesDevicesGet>>>;
export type ListDevicesDevicesGetQueryError = HTTPValidationError;

/**
 * @summary List devices
 */
export const useListDevicesDevicesGet = <TError = HTTPValidationError>(
    params?: ListDevicesDevicesGetParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listDevicesDevicesGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof listDevicesDevicesGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getListDevicesDevicesGetKey(params) : null));
    const swrFn = () => listDevicesDevicesGet(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List specific device from heartbeat registry
 * @summary List specific device
 */
export const getGetDeviceDevicesDeviceIdGetUrl = (deviceId: string) => {
    return `/devices/${deviceId}`;
};

export const getDeviceDevicesDeviceIdGet = async (
    deviceId: string,
    options?: RequestInit,
): Promise<GetDeviceDevicesDeviceIdGet200> => {
    return getDeviceDevicesDeviceIdGetMutator<GetDeviceDevicesDeviceIdGet200>(
        getGetDeviceDevicesDeviceIdGetUrl(deviceId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetDeviceDevicesDeviceIdGetKey = (deviceId: string) => [`/devices/${deviceId}`] as const;

export type GetDeviceDevicesDeviceIdGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceDevicesDeviceIdGet>>
>;
export type GetDeviceDevicesDeviceIdGetQueryError = ErrorDeviceNotFound | HTTPValidationError;

/**
 * @summary List specific device
 */
export const useGetDeviceDevicesDeviceIdGet = <TError = ErrorDeviceNotFound | HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceDevicesDeviceIdGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceDevicesDeviceIdGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!deviceId;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceDevicesDeviceIdGetKey(deviceId) : null));
    const swrFn = () => getDeviceDevicesDeviceIdGet(deviceId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Query device status via UDP control.
 * @summary Get device status
 */
export const getGetDeviceStatusDevicesDeviceIdStatusGetUrl = (deviceId: string) => {
    return `/devices/${deviceId}/status`;
};

export const getDeviceStatusDevicesDeviceIdStatusGet = async (
    deviceId: string,
    options?: RequestInit,
): Promise<GetDeviceStatusDevicesDeviceIdStatusGet200> => {
    return getDeviceStatusDevicesDeviceIdStatusGetMutator<GetDeviceStatusDevicesDeviceIdStatusGet200>(
        getGetDeviceStatusDevicesDeviceIdStatusGetUrl(deviceId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetDeviceStatusDevicesDeviceIdStatusGetKey = (deviceId: string) =>
    [`/devices/${deviceId}/status`] as const;

export type GetDeviceStatusDevicesDeviceIdStatusGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceStatusDevicesDeviceIdStatusGet>>
>;
export type GetDeviceStatusDevicesDeviceIdStatusGetQueryError =
    | ErrorNotSupportedInMode
    | GetDeviceStatusDevicesDeviceIdStatusGet404
    | ErrorBadStatusResponse
    | ErrorDependencyFailure;

/**
 * @summary Get device status
 */
export const useGetDeviceStatusDevicesDeviceIdStatusGet = <
    TError =
        | ErrorNotSupportedInMode
        | GetDeviceStatusDevicesDeviceIdStatusGet404
        | ErrorBadStatusResponse
        | ErrorDependencyFailure,
>(
    deviceId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceStatusDevicesDeviceIdStatusGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceStatusDevicesDeviceIdStatusGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!deviceId;
    const swrKey =
        swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceStatusDevicesDeviceIdStatusGetKey(deviceId) : null));
    const swrFn = () => getDeviceStatusDevicesDeviceIdStatusGet(deviceId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get current SDR device configuration from heartbeat
 * @summary Get device configuration
 */
export const getGetDeviceCfgDevicesDeviceIdConfigGetUrl = (deviceId: string) => {
    return `/devices/${deviceId}/config`;
};

export const getDeviceCfgDevicesDeviceIdConfigGet = async (
    deviceId: string,
    options?: RequestInit,
): Promise<GetDeviceCfgDevicesDeviceIdConfigGet200> => {
    return getDeviceCfgDevicesDeviceIdConfigGetMutator<GetDeviceCfgDevicesDeviceIdConfigGet200>(
        getGetDeviceCfgDevicesDeviceIdConfigGetUrl(deviceId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetDeviceCfgDevicesDeviceIdConfigGetKey = (deviceId: string) =>
    [`/devices/${deviceId}/config`] as const;

export type GetDeviceCfgDevicesDeviceIdConfigGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceCfgDevicesDeviceIdConfigGet>>
>;
export type GetDeviceCfgDevicesDeviceIdConfigGetQueryError =
    | ErrorNotSupportedInMode
    | GetDeviceCfgDevicesDeviceIdConfigGet404
    | ErrorBadCfgResponse
    | ErrorDependencyFailure;

/**
 * @summary Get device configuration
 */
export const useGetDeviceCfgDevicesDeviceIdConfigGet = <
    TError =
        | ErrorNotSupportedInMode
        | GetDeviceCfgDevicesDeviceIdConfigGet404
        | ErrorBadCfgResponse
        | ErrorDependencyFailure,
>(
    deviceId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceCfgDevicesDeviceIdConfigGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceCfgDevicesDeviceIdConfigGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!deviceId;
    const swrKey =
        swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceCfgDevicesDeviceIdConfigGetKey(deviceId) : null));
    const swrFn = () => getDeviceCfgDevicesDeviceIdConfigGet(deviceId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Update SDR device configuration via UDP control.
 * @summary Update device configuration
 */
export const getUpdateDeviceCfgDevicesDeviceIdConfigPatchUrl = (
    deviceId: string,
    params?: UpdateDeviceCfgDevicesDeviceIdConfigPatchParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/devices/${deviceId}/config?${stringifiedParams}`
        : `/devices/${deviceId}/config`;
};

export const updateDeviceCfgDevicesDeviceIdConfigPatch = async (
    deviceId: string,
    sDRConfigParams: SDRConfigParams,
    params?: UpdateDeviceCfgDevicesDeviceIdConfigPatchParams,
    options?: RequestInit,
): Promise<unknown> => {
    return updateDeviceCfgDevicesDeviceIdConfigPatchMutator<unknown>(
        getUpdateDeviceCfgDevicesDeviceIdConfigPatchUrl(deviceId, params),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(sDRConfigParams),
        },
    );
};

export const getUpdateDeviceCfgDevicesDeviceIdConfigPatchMutationFetcher = (
    deviceId: string,
    params?: UpdateDeviceCfgDevicesDeviceIdConfigPatchParams,
    options?: SecondParameter<typeof updateDeviceCfgDevicesDeviceIdConfigPatchMutator>,
) => {
    return (_: Key, { arg }: { arg: SDRConfigParams }) => {
        return updateDeviceCfgDevicesDeviceIdConfigPatch(deviceId, arg, params, options);
    };
};
export const getUpdateDeviceCfgDevicesDeviceIdConfigPatchMutationKey = (
    deviceId: string,
    params?: UpdateDeviceCfgDevicesDeviceIdConfigPatchParams,
) => [`/devices/${deviceId}/config`, ...(params ? [params] : [])] as const;

export type UpdateDeviceCfgDevicesDeviceIdConfigPatchMutationResult = NonNullable<
    Awaited<ReturnType<typeof updateDeviceCfgDevicesDeviceIdConfigPatch>>
>;
export type UpdateDeviceCfgDevicesDeviceIdConfigPatchMutationError = HTTPValidationError;

/**
 * @summary Update device configuration
 */
export const useUpdateDeviceCfgDevicesDeviceIdConfigPatch = <TError = HTTPValidationError>(
    deviceId: string,
    params?: UpdateDeviceCfgDevicesDeviceIdConfigPatchParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof updateDeviceCfgDevicesDeviceIdConfigPatch>>,
            TError,
            Key,
            SDRConfigParams,
            Awaited<ReturnType<typeof updateDeviceCfgDevicesDeviceIdConfigPatch>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof updateDeviceCfgDevicesDeviceIdConfigPatchMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUpdateDeviceCfgDevicesDeviceIdConfigPatchMutationKey(deviceId, params);
    const swrFn = getUpdateDeviceCfgDevicesDeviceIdConfigPatchMutationFetcher(deviceId, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get baseline data from device.
 * @summary Get baseline data
 */
export const getGetDeviceBaselineDevicesDeviceIdBaselineGetUrl = (deviceId: string) => {
    return `/devices/${deviceId}/baseline`;
};

export const getDeviceBaselineDevicesDeviceIdBaselineGet = async (
    deviceId: string,
    options?: RequestInit,
): Promise<ResponseBaseline> => {
    return getDeviceBaselineDevicesDeviceIdBaselineGetMutator<ResponseBaseline>(
        getGetDeviceBaselineDevicesDeviceIdBaselineGetUrl(deviceId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetDeviceBaselineDevicesDeviceIdBaselineGetKey = (deviceId: string) =>
    [`/devices/${deviceId}/baseline`] as const;

export type GetDeviceBaselineDevicesDeviceIdBaselineGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceBaselineDevicesDeviceIdBaselineGet>>
>;
export type GetDeviceBaselineDevicesDeviceIdBaselineGetQueryError =
    | ErrorNotSupportedInMode
    | GetDeviceBaselineDevicesDeviceIdBaselineGet404
    | HTTPValidationError
    | GetDeviceBaselineDevicesDeviceIdBaselineGet424;

/**
 * @summary Get baseline data
 */
export const useGetDeviceBaselineDevicesDeviceIdBaselineGet = <
    TError =
        | ErrorNotSupportedInMode
        | GetDeviceBaselineDevicesDeviceIdBaselineGet404
        | HTTPValidationError
        | GetDeviceBaselineDevicesDeviceIdBaselineGet424,
>(
    deviceId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceBaselineDevicesDeviceIdBaselineGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceBaselineDevicesDeviceIdBaselineGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!deviceId;
    const swrKey =
        swrOptions?.swrKey ?? (() => (isEnabled ? getGetDeviceBaselineDevicesDeviceIdBaselineGetKey(deviceId) : null));
    const swrFn = () => getDeviceBaselineDevicesDeviceIdBaselineGet(deviceId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List available baseline files on device.
 * @summary List baseline files
 */
export const getListBaselineFilesDevicesDeviceIdBaselineListGetUrl = (deviceId: string) => {
    return `/devices/${deviceId}/baseline/list`;
};

export const listBaselineFilesDevicesDeviceIdBaselineListGet = async (
    deviceId: string,
    options?: RequestInit,
): Promise<ResponseFileList> => {
    return listBaselineFilesDevicesDeviceIdBaselineListGetMutator<ResponseFileList>(
        getListBaselineFilesDevicesDeviceIdBaselineListGetUrl(deviceId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getListBaselineFilesDevicesDeviceIdBaselineListGetKey = (deviceId: string) =>
    [`/devices/${deviceId}/baseline/list`] as const;

export type ListBaselineFilesDevicesDeviceIdBaselineListGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof listBaselineFilesDevicesDeviceIdBaselineListGet>>
>;
export type ListBaselineFilesDevicesDeviceIdBaselineListGetQueryError =
    | ErrorNotSupportedInMode
    | ListBaselineFilesDevicesDeviceIdBaselineListGet404
    | HTTPValidationError
    | ListBaselineFilesDevicesDeviceIdBaselineListGet424;

/**
 * @summary List baseline files
 */
export const useListBaselineFilesDevicesDeviceIdBaselineListGet = <
    TError =
        | ErrorNotSupportedInMode
        | ListBaselineFilesDevicesDeviceIdBaselineListGet404
        | HTTPValidationError
        | ListBaselineFilesDevicesDeviceIdBaselineListGet424,
>(
    deviceId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof listBaselineFilesDevicesDeviceIdBaselineListGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof listBaselineFilesDevicesDeviceIdBaselineListGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!deviceId;
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getListBaselineFilesDevicesDeviceIdBaselineListGetKey(deviceId) : null));
    const swrFn = () => listBaselineFilesDevicesDeviceIdBaselineListGet(deviceId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * List available archive files on device for specific mode.
 * @summary List archive files for mode
 */
export const getListSweepArchivesDevicesDeviceIdArchiveModeListGetUrl = (
    deviceId: string,
    mode: 'sweep' | 'center',
) => {
    return `/devices/${deviceId}/archive/${mode}/list`;
};

export const listSweepArchivesDevicesDeviceIdArchiveModeListGet = async (
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: RequestInit,
): Promise<ResponseFileList> => {
    return listSweepArchivesDevicesDeviceIdArchiveModeListGetMutator<ResponseFileList>(
        getListSweepArchivesDevicesDeviceIdArchiveModeListGetUrl(deviceId, mode),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getListSweepArchivesDevicesDeviceIdArchiveModeListGetKey = (deviceId: string, mode: 'sweep' | 'center') =>
    [`/devices/${deviceId}/archive/${mode}/list`] as const;

export type ListSweepArchivesDevicesDeviceIdArchiveModeListGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof listSweepArchivesDevicesDeviceIdArchiveModeListGet>>
>;
export type ListSweepArchivesDevicesDeviceIdArchiveModeListGetQueryError =
    | ErrorNotSupportedInMode
    | ListSweepArchivesDevicesDeviceIdArchiveModeListGet404
    | HTTPValidationError
    | ListSweepArchivesDevicesDeviceIdArchiveModeListGet424;

/**
 * @summary List archive files for mode
 */
export const useListSweepArchivesDevicesDeviceIdArchiveModeListGet = <
    TError =
        | ErrorNotSupportedInMode
        | ListSweepArchivesDevicesDeviceIdArchiveModeListGet404
        | HTTPValidationError
        | ListSweepArchivesDevicesDeviceIdArchiveModeListGet424,
>(
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof listSweepArchivesDevicesDeviceIdArchiveModeListGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof listSweepArchivesDevicesDeviceIdArchiveModeListGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!(deviceId && mode);
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getListSweepArchivesDevicesDeviceIdArchiveModeListGetKey(deviceId, mode) : null));
    const swrFn = () => listSweepArchivesDevicesDeviceIdArchiveModeListGet(deviceId, mode, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Download all .bin archive files as tar.gz from the device for specific mode.
 * @summary Download all archive files for mode
 */
export const getDownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetUrl = (
    deviceId: string,
    mode: 'sweep' | 'center',
) => {
    return `/devices/${deviceId}/archive/download/${mode}/all`;
};

export const downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet = async (
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: RequestInit,
): Promise<unknown | Blob> => {
    return downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetMutator<unknown | Blob>(
        getDownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetUrl(deviceId, mode),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getDownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetKey = (
    deviceId: string,
    mode: 'sweep' | 'center',
) => [`/devices/${deviceId}/archive/download/${mode}/all`] as const;

export type DownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet>>
>;
export type DownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetQueryError =
    | ErrorNotSupportedInMode
    | ErrorDeviceNotFound
    | HTTPValidationError
    | DownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet424;

/**
 * @summary Download all archive files for mode
 */
export const useDownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet = <
    TError =
        | ErrorNotSupportedInMode
        | ErrorDeviceNotFound
        | HTTPValidationError
        | DownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet424,
>(
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!(deviceId && mode);
    const swrKey =
        swrOptions?.swrKey ??
        (() =>
            isEnabled ? getDownloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGetKey(deviceId, mode) : null);
    const swrFn = () => downloadAllArchiveFilesDevicesDeviceIdArchiveDownloadModeAllGet(deviceId, mode, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Download any archive file from device.
 * @summary Download any archive file
 */
export const getDownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetUrl = (
    deviceId: string,
    filename: string,
) => {
    return `/devices/${deviceId}/archive/download/${filename}`;
};

export const downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet = async (
    deviceId: string,
    filename: string,
    options?: RequestInit,
): Promise<unknown | Blob> => {
    return downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetMutator<unknown | Blob>(
        getDownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetUrl(deviceId, filename),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getDownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetKey = (
    deviceId: string,
    filename: string,
) => [`/devices/${deviceId}/archive/download/${filename}`] as const;

export type DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet>>
>;
export type DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetQueryError =
    | ErrorInvalidFilename
    | ErrorNotSupportedInMode
    | DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet404
    | ErrorInvalidHeader
    | DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet424;

/**
 * @summary Download any archive file
 */
export const useDownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet = <
    TError =
        | ErrorInvalidFilename
        | ErrorNotSupportedInMode
        | DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet404
        | ErrorInvalidHeader
        | DownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet424,
>(
    deviceId: string,
    filename: string,
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!(deviceId && filename);
    const swrKey =
        swrOptions?.swrKey ??
        (() =>
            isEnabled ? getDownloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGetKey(deviceId, filename) : null);
    const swrFn = () =>
        downloadArchiveFileDevicesDeviceIdArchiveDownloadFilenameGet(deviceId, filename, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Set device mode (e.g. sweep, center). This will cause the device to restart and apply the new mode.
 * @summary Switch device mode
 */
export const getSwitchDeviceModeDevicesDeviceIdModeModePostUrl = (deviceId: string, mode: 'sweep' | 'center') => {
    return `/devices/${deviceId}/mode/${mode}`;
};

export const switchDeviceModeDevicesDeviceIdModeModePost = async (
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: RequestInit,
): Promise<unknown> => {
    return switchDeviceModeDevicesDeviceIdModeModePostMutator<unknown>(
        getSwitchDeviceModeDevicesDeviceIdModeModePostUrl(deviceId, mode),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getSwitchDeviceModeDevicesDeviceIdModeModePostMutationFetcher = (
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: SecondParameter<typeof switchDeviceModeDevicesDeviceIdModeModePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return switchDeviceModeDevicesDeviceIdModeModePost(deviceId, mode, options);
    };
};
export const getSwitchDeviceModeDevicesDeviceIdModeModePostMutationKey = (deviceId: string, mode: 'sweep' | 'center') =>
    [`/devices/${deviceId}/mode/${mode}`] as const;

export type SwitchDeviceModeDevicesDeviceIdModeModePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof switchDeviceModeDevicesDeviceIdModeModePost>>
>;
export type SwitchDeviceModeDevicesDeviceIdModeModePostMutationError = HTTPValidationError;

/**
 * @summary Switch device mode
 */
export const useSwitchDeviceModeDevicesDeviceIdModeModePost = <TError = HTTPValidationError>(
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof switchDeviceModeDevicesDeviceIdModeModePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof switchDeviceModeDevicesDeviceIdModeModePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof switchDeviceModeDevicesDeviceIdModeModePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSwitchDeviceModeDevicesDeviceIdModeModePostMutationKey(deviceId, mode);
    const swrFn = getSwitchDeviceModeDevicesDeviceIdModeModePostMutationFetcher(deviceId, mode, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Start baseline data collection on selected devices.
 * @summary Start baseline collection
 */
export const getBaselineStartDevicesBaselineStartPostUrl = () => {
    return `/devices/baseline/start`;
};

export const baselineStartDevicesBaselineStartPost = async (
    deviceIdsStart: DeviceIdsStart,
    options?: RequestInit,
): Promise<unknown> => {
    return baselineStartDevicesBaselineStartPostMutator<unknown>(getBaselineStartDevicesBaselineStartPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceIdsStart),
    });
};

export const getBaselineStartDevicesBaselineStartPostMutationFetcher = (
    options?: SecondParameter<typeof baselineStartDevicesBaselineStartPostMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceIdsStart }) => {
        return baselineStartDevicesBaselineStartPost(arg, options);
    };
};
export const getBaselineStartDevicesBaselineStartPostMutationKey = () => [`/devices/baseline/start`] as const;

export type BaselineStartDevicesBaselineStartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof baselineStartDevicesBaselineStartPost>>
>;
export type BaselineStartDevicesBaselineStartPostMutationError = HTTPValidationError;

/**
 * @summary Start baseline collection
 */
export const useBaselineStartDevicesBaselineStartPost = <TError = HTTPValidationError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof baselineStartDevicesBaselineStartPost>>,
        TError,
        Key,
        DeviceIdsStart,
        Awaited<ReturnType<typeof baselineStartDevicesBaselineStartPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof baselineStartDevicesBaselineStartPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getBaselineStartDevicesBaselineStartPostMutationKey();
    const swrFn = getBaselineStartDevicesBaselineStartPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Stop baseline data collection on selected devices.
 * @summary Stop baseline collection
 */
export const getBaselineStopDevicesBaselineStopPostUrl = () => {
    return `/devices/baseline/stop`;
};

export const baselineStopDevicesBaselineStopPost = async (
    deviceIdsStop: DeviceIdsStop,
    options?: RequestInit,
): Promise<unknown> => {
    return baselineStopDevicesBaselineStopPostMutator<unknown>(getBaselineStopDevicesBaselineStopPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceIdsStop),
    });
};

export const getBaselineStopDevicesBaselineStopPostMutationFetcher = (
    options?: SecondParameter<typeof baselineStopDevicesBaselineStopPostMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceIdsStop }) => {
        return baselineStopDevicesBaselineStopPost(arg, options);
    };
};
export const getBaselineStopDevicesBaselineStopPostMutationKey = () => [`/devices/baseline/stop`] as const;

export type BaselineStopDevicesBaselineStopPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof baselineStopDevicesBaselineStopPost>>
>;
export type BaselineStopDevicesBaselineStopPostMutationError = HTTPValidationError;

/**
 * @summary Stop baseline collection
 */
export const useBaselineStopDevicesBaselineStopPost = <TError = HTTPValidationError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof baselineStopDevicesBaselineStopPost>>,
        TError,
        Key,
        DeviceIdsStop,
        Awaited<ReturnType<typeof baselineStopDevicesBaselineStopPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof baselineStopDevicesBaselineStopPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getBaselineStopDevicesBaselineStopPostMutationKey();
    const swrFn = getBaselineStopDevicesBaselineStopPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Load a baseline file on device.
 * @summary Load baseline file
 */
export const getLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostUrl = (deviceId: string, filename: string) => {
    return `/devices/${deviceId}/baseline/load/${filename}`;
};

export const loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePost = async (
    deviceId: string,
    filename: string,
    options?: RequestInit,
): Promise<unknown> => {
    return loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutator<unknown>(
        getLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostUrl(deviceId, filename),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutationFetcher = (
    deviceId: string,
    filename: string,
    options?: SecondParameter<typeof loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePost(deviceId, filename, options);
    };
};
export const getLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutationKey = (
    deviceId: string,
    filename: string,
) => [`/devices/${deviceId}/baseline/load/${filename}`] as const;

export type LoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePost>>
>;
export type LoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutationError = HTTPValidationError;

/**
 * @summary Load baseline file
 */
export const useLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePost = <TError = HTTPValidationError>(
    deviceId: string,
    filename: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof loadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutationKey(deviceId, filename);
    const swrFn = getLoadBaselineFileDevicesDeviceIdBaselineLoadFilenamePostMutationFetcher(
        deviceId,
        filename,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Start live data streaming for a specified device.
 * @summary Start live stream
 */
export const getSdrLiveStartDevicesDeviceIdLiveStartPostUrl = (
    deviceId: string,
    params?: SdrLiveStartDevicesDeviceIdLiveStartPostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/devices/${deviceId}/live/start?${stringifiedParams}`
        : `/devices/${deviceId}/live/start`;
};

export const sdrLiveStartDevicesDeviceIdLiveStartPost = async (
    deviceId: string,
    params?: SdrLiveStartDevicesDeviceIdLiveStartPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return sdrLiveStartDevicesDeviceIdLiveStartPostMutator<unknown>(
        getSdrLiveStartDevicesDeviceIdLiveStartPostUrl(deviceId, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getSdrLiveStartDevicesDeviceIdLiveStartPostMutationFetcher = (
    deviceId: string,
    params?: SdrLiveStartDevicesDeviceIdLiveStartPostParams,
    options?: SecondParameter<typeof sdrLiveStartDevicesDeviceIdLiveStartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return sdrLiveStartDevicesDeviceIdLiveStartPost(deviceId, params, options);
    };
};
export const getSdrLiveStartDevicesDeviceIdLiveStartPostMutationKey = (
    deviceId: string,
    params?: SdrLiveStartDevicesDeviceIdLiveStartPostParams,
) => [`/devices/${deviceId}/live/start`, ...(params ? [params] : [])] as const;

export type SdrLiveStartDevicesDeviceIdLiveStartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof sdrLiveStartDevicesDeviceIdLiveStartPost>>
>;
export type SdrLiveStartDevicesDeviceIdLiveStartPostMutationError = HTTPValidationError;

/**
 * @summary Start live stream
 */
export const useSdrLiveStartDevicesDeviceIdLiveStartPost = <TError = HTTPValidationError>(
    deviceId: string,
    params?: SdrLiveStartDevicesDeviceIdLiveStartPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof sdrLiveStartDevicesDeviceIdLiveStartPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof sdrLiveStartDevicesDeviceIdLiveStartPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof sdrLiveStartDevicesDeviceIdLiveStartPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSdrLiveStartDevicesDeviceIdLiveStartPostMutationKey(deviceId, params);
    const swrFn = getSdrLiveStartDevicesDeviceIdLiveStartPostMutationFetcher(deviceId, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Stop live data streaming for a specified device.
 * @summary Stop live stream
 */
export const getSdrLiveStopDevicesDeviceIdLiveStopPostUrl = (
    deviceId: string,
    params?: SdrLiveStopDevicesDeviceIdLiveStopPostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/devices/${deviceId}/live/stop?${stringifiedParams}`
        : `/devices/${deviceId}/live/stop`;
};

export const sdrLiveStopDevicesDeviceIdLiveStopPost = async (
    deviceId: string,
    params?: SdrLiveStopDevicesDeviceIdLiveStopPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return sdrLiveStopDevicesDeviceIdLiveStopPostMutator<unknown>(
        getSdrLiveStopDevicesDeviceIdLiveStopPostUrl(deviceId, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getSdrLiveStopDevicesDeviceIdLiveStopPostMutationFetcher = (
    deviceId: string,
    params?: SdrLiveStopDevicesDeviceIdLiveStopPostParams,
    options?: SecondParameter<typeof sdrLiveStopDevicesDeviceIdLiveStopPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return sdrLiveStopDevicesDeviceIdLiveStopPost(deviceId, params, options);
    };
};
export const getSdrLiveStopDevicesDeviceIdLiveStopPostMutationKey = (
    deviceId: string,
    params?: SdrLiveStopDevicesDeviceIdLiveStopPostParams,
) => [`/devices/${deviceId}/live/stop`, ...(params ? [params] : [])] as const;

export type SdrLiveStopDevicesDeviceIdLiveStopPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof sdrLiveStopDevicesDeviceIdLiveStopPost>>
>;
export type SdrLiveStopDevicesDeviceIdLiveStopPostMutationError = HTTPValidationError;

/**
 * @summary Stop live stream
 */
export const useSdrLiveStopDevicesDeviceIdLiveStopPost = <TError = HTTPValidationError>(
    deviceId: string,
    params?: SdrLiveStopDevicesDeviceIdLiveStopPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof sdrLiveStopDevicesDeviceIdLiveStopPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof sdrLiveStopDevicesDeviceIdLiveStopPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof sdrLiveStopDevicesDeviceIdLiveStopPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSdrLiveStopDevicesDeviceIdLiveStopPostMutationKey(deviceId, params);
    const swrFn = getSdrLiveStopDevicesDeviceIdLiveStopPostMutationFetcher(deviceId, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Subscribe a connected WS client to an already running live stream
 * @summary Subscribe to live stream
 */
export const getLiveSubscribeDevicesDeviceIdLiveSubscribePostUrl = (
    deviceId: string,
    params?: LiveSubscribeDevicesDeviceIdLiveSubscribePostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/devices/${deviceId}/live/subscribe?${stringifiedParams}`
        : `/devices/${deviceId}/live/subscribe`;
};

export const liveSubscribeDevicesDeviceIdLiveSubscribePost = async (
    deviceId: string,
    params?: LiveSubscribeDevicesDeviceIdLiveSubscribePostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return liveSubscribeDevicesDeviceIdLiveSubscribePostMutator<unknown>(
        getLiveSubscribeDevicesDeviceIdLiveSubscribePostUrl(deviceId, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getLiveSubscribeDevicesDeviceIdLiveSubscribePostMutationFetcher = (
    deviceId: string,
    params?: LiveSubscribeDevicesDeviceIdLiveSubscribePostParams,
    options?: SecondParameter<typeof liveSubscribeDevicesDeviceIdLiveSubscribePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return liveSubscribeDevicesDeviceIdLiveSubscribePost(deviceId, params, options);
    };
};
export const getLiveSubscribeDevicesDeviceIdLiveSubscribePostMutationKey = (
    deviceId: string,
    params?: LiveSubscribeDevicesDeviceIdLiveSubscribePostParams,
) => [`/devices/${deviceId}/live/subscribe`, ...(params ? [params] : [])] as const;

export type LiveSubscribeDevicesDeviceIdLiveSubscribePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof liveSubscribeDevicesDeviceIdLiveSubscribePost>>
>;
export type LiveSubscribeDevicesDeviceIdLiveSubscribePostMutationError = HTTPValidationError;

/**
 * @summary Subscribe to live stream
 */
export const useLiveSubscribeDevicesDeviceIdLiveSubscribePost = <TError = HTTPValidationError>(
    deviceId: string,
    params?: LiveSubscribeDevicesDeviceIdLiveSubscribePostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof liveSubscribeDevicesDeviceIdLiveSubscribePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof liveSubscribeDevicesDeviceIdLiveSubscribePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof liveSubscribeDevicesDeviceIdLiveSubscribePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getLiveSubscribeDevicesDeviceIdLiveSubscribePostMutationKey(deviceId, params);
    const swrFn = getLiveSubscribeDevicesDeviceIdLiveSubscribePostMutationFetcher(deviceId, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Unsubscribe a connected WS client from live stream
 * @summary Unsubscribe from live stream
 */
export const getLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostUrl = (
    deviceId: string,
    params?: LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/devices/${deviceId}/live/unsubscribe?${stringifiedParams}`
        : `/devices/${deviceId}/live/unsubscribe`;
};

export const liveUnsubscribeDevicesDeviceIdLiveUnsubscribePost = async (
    deviceId: string,
    params?: LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return liveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutator<unknown>(
        getLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostUrl(deviceId, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutationFetcher = (
    deviceId: string,
    params?: LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostParams,
    options?: SecondParameter<typeof liveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return liveUnsubscribeDevicesDeviceIdLiveUnsubscribePost(deviceId, params, options);
    };
};
export const getLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutationKey = (
    deviceId: string,
    params?: LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostParams,
) => [`/devices/${deviceId}/live/unsubscribe`, ...(params ? [params] : [])] as const;

export type LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof liveUnsubscribeDevicesDeviceIdLiveUnsubscribePost>>
>;
export type LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutationError = HTTPValidationError;

/**
 * @summary Unsubscribe from live stream
 */
export const useLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePost = <TError = HTTPValidationError>(
    deviceId: string,
    params?: LiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof liveUnsubscribeDevicesDeviceIdLiveUnsubscribePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof liveUnsubscribeDevicesDeviceIdLiveUnsubscribePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof liveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutationKey(deviceId, params);
    const swrFn = getLiveUnsubscribeDevicesDeviceIdLiveUnsubscribePostMutationFetcher(deviceId, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable current engine (sweep, center) on all connected devices.
 * @summary Start SDR engine on all devices
 */
export const getEngineStartAllDevicesAllStartPostUrl = () => {
    return `/devices/all/start`;
};

export const engineStartAllDevicesAllStartPost = async (options?: RequestInit): Promise<unknown> => {
    return engineStartAllDevicesAllStartPostMutator<unknown>(getEngineStartAllDevicesAllStartPostUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getEngineStartAllDevicesAllStartPostMutationFetcher = (
    options?: SecondParameter<typeof engineStartAllDevicesAllStartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return engineStartAllDevicesAllStartPost(options);
    };
};
export const getEngineStartAllDevicesAllStartPostMutationKey = () => [`/devices/all/start`] as const;

export type EngineStartAllDevicesAllStartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof engineStartAllDevicesAllStartPost>>
>;
export type EngineStartAllDevicesAllStartPostMutationError = unknown;

/**
 * @summary Start SDR engine on all devices
 */
export const useEngineStartAllDevicesAllStartPost = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof engineStartAllDevicesAllStartPost>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof engineStartAllDevicesAllStartPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof engineStartAllDevicesAllStartPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getEngineStartAllDevicesAllStartPostMutationKey();
    const swrFn = getEngineStartAllDevicesAllStartPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable current engine (sweep, center) on all connected devices.
 * @summary Stop SDR engine on all devices
 */
export const getEngineStopAllDevicesAllStopPostUrl = () => {
    return `/devices/all/stop`;
};

export const engineStopAllDevicesAllStopPost = async (options?: RequestInit): Promise<unknown> => {
    return engineStopAllDevicesAllStopPostMutator<unknown>(getEngineStopAllDevicesAllStopPostUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getEngineStopAllDevicesAllStopPostMutationFetcher = (
    options?: SecondParameter<typeof engineStopAllDevicesAllStopPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return engineStopAllDevicesAllStopPost(options);
    };
};
export const getEngineStopAllDevicesAllStopPostMutationKey = () => [`/devices/all/stop`] as const;

export type EngineStopAllDevicesAllStopPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof engineStopAllDevicesAllStopPost>>
>;
export type EngineStopAllDevicesAllStopPostMutationError = unknown;

/**
 * @summary Stop SDR engine on all devices
 */
export const useEngineStopAllDevicesAllStopPost = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof engineStopAllDevicesAllStopPost>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof engineStopAllDevicesAllStopPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof engineStopAllDevicesAllStopPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getEngineStopAllDevicesAllStopPostMutationKey();
    const swrFn = getEngineStopAllDevicesAllStopPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable current engine (sweep, center) on device.
 * @summary Start SDR engine
 */
export const getEngineStartDevicesDeviceIdStartPostUrl = (deviceId: string) => {
    return `/devices/${deviceId}/start`;
};

export const engineStartDevicesDeviceIdStartPost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return engineStartDevicesDeviceIdStartPostMutator<unknown>(getEngineStartDevicesDeviceIdStartPostUrl(deviceId), {
        ...options,
        method: 'POST',
    });
};

export const getEngineStartDevicesDeviceIdStartPostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof engineStartDevicesDeviceIdStartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return engineStartDevicesDeviceIdStartPost(deviceId, options);
    };
};
export const getEngineStartDevicesDeviceIdStartPostMutationKey = (deviceId: string) =>
    [`/devices/${deviceId}/start`] as const;

export type EngineStartDevicesDeviceIdStartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof engineStartDevicesDeviceIdStartPost>>
>;
export type EngineStartDevicesDeviceIdStartPostMutationError = HTTPValidationError;

/**
 * @summary Start SDR engine
 */
export const useEngineStartDevicesDeviceIdStartPost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof engineStartDevicesDeviceIdStartPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof engineStartDevicesDeviceIdStartPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof engineStartDevicesDeviceIdStartPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getEngineStartDevicesDeviceIdStartPostMutationKey(deviceId);
    const swrFn = getEngineStartDevicesDeviceIdStartPostMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable current engine (sweep, center) on device.
 * @summary Stop SDR engine
 */
export const getEngineStopDevicesDeviceIdStopPostUrl = (deviceId: string) => {
    return `/devices/${deviceId}/stop`;
};

export const engineStopDevicesDeviceIdStopPost = async (deviceId: string, options?: RequestInit): Promise<unknown> => {
    return engineStopDevicesDeviceIdStopPostMutator<unknown>(getEngineStopDevicesDeviceIdStopPostUrl(deviceId), {
        ...options,
        method: 'POST',
    });
};

export const getEngineStopDevicesDeviceIdStopPostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof engineStopDevicesDeviceIdStopPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return engineStopDevicesDeviceIdStopPost(deviceId, options);
    };
};
export const getEngineStopDevicesDeviceIdStopPostMutationKey = (deviceId: string) =>
    [`/devices/${deviceId}/stop`] as const;

export type EngineStopDevicesDeviceIdStopPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof engineStopDevicesDeviceIdStopPost>>
>;
export type EngineStopDevicesDeviceIdStopPostMutationError = HTTPValidationError;

/**
 * @summary Stop SDR engine
 */
export const useEngineStopDevicesDeviceIdStopPost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof engineStopDevicesDeviceIdStopPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof engineStopDevicesDeviceIdStopPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof engineStopDevicesDeviceIdStopPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getEngineStopDevicesDeviceIdStopPostMutationKey(deviceId);
    const swrFn = getEngineStopDevicesDeviceIdStopPostMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable saving data in current mode on all connected devices.
 * @summary Start saving data in current mode on all devices
 */
export const getSaveStartAllDevicesAllSaveStartPostUrl = (params?: SaveStartAllDevicesAllSaveStartPostParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/devices/all/save/start?${stringifiedParams}` : `/devices/all/save/start`;
};

export const saveStartAllDevicesAllSaveStartPost = async (
    params?: SaveStartAllDevicesAllSaveStartPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return saveStartAllDevicesAllSaveStartPostMutator<unknown>(getSaveStartAllDevicesAllSaveStartPostUrl(params), {
        ...options,
        method: 'POST',
    });
};

export const getSaveStartAllDevicesAllSaveStartPostMutationFetcher = (
    params?: SaveStartAllDevicesAllSaveStartPostParams,
    options?: SecondParameter<typeof saveStartAllDevicesAllSaveStartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return saveStartAllDevicesAllSaveStartPost(params, options);
    };
};
export const getSaveStartAllDevicesAllSaveStartPostMutationKey = (params?: SaveStartAllDevicesAllSaveStartPostParams) =>
    [`/devices/all/save/start`, ...(params ? [params] : [])] as const;

export type SaveStartAllDevicesAllSaveStartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof saveStartAllDevicesAllSaveStartPost>>
>;
export type SaveStartAllDevicesAllSaveStartPostMutationError = HTTPValidationError;

/**
 * @summary Start saving data in current mode on all devices
 */
export const useSaveStartAllDevicesAllSaveStartPost = <TError = HTTPValidationError>(
    params?: SaveStartAllDevicesAllSaveStartPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof saveStartAllDevicesAllSaveStartPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof saveStartAllDevicesAllSaveStartPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof saveStartAllDevicesAllSaveStartPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSaveStartAllDevicesAllSaveStartPostMutationKey(params);
    const swrFn = getSaveStartAllDevicesAllSaveStartPostMutationFetcher(params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable saving data in current mode on all connected devices.
 * @summary Stop saving data in current mode on all devices
 */
export const getSaveStopAllDevicesAllSaveStopPostUrl = () => {
    return `/devices/all/save/stop`;
};

export const saveStopAllDevicesAllSaveStopPost = async (options?: RequestInit): Promise<unknown> => {
    return saveStopAllDevicesAllSaveStopPostMutator<unknown>(getSaveStopAllDevicesAllSaveStopPostUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getSaveStopAllDevicesAllSaveStopPostMutationFetcher = (
    options?: SecondParameter<typeof saveStopAllDevicesAllSaveStopPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return saveStopAllDevicesAllSaveStopPost(options);
    };
};
export const getSaveStopAllDevicesAllSaveStopPostMutationKey = () => [`/devices/all/save/stop`] as const;

export type SaveStopAllDevicesAllSaveStopPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof saveStopAllDevicesAllSaveStopPost>>
>;
export type SaveStopAllDevicesAllSaveStopPostMutationError = unknown;

/**
 * @summary Stop saving data in current mode on all devices
 */
export const useSaveStopAllDevicesAllSaveStopPost = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof saveStopAllDevicesAllSaveStopPost>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof saveStopAllDevicesAllSaveStopPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof saveStopAllDevicesAllSaveStopPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSaveStopAllDevicesAllSaveStopPostMutationKey();
    const swrFn = getSaveStopAllDevicesAllSaveStopPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable saving data in current on device.
 * @summary Start saving data in current mode
 */
export const getSaveStartDevicesDeviceIdSaveStartPostUrl = (
    deviceId: string,
    params?: SaveStartDevicesDeviceIdSaveStartPostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/devices/${deviceId}/save/start?${stringifiedParams}`
        : `/devices/${deviceId}/save/start`;
};

export const saveStartDevicesDeviceIdSaveStartPost = async (
    deviceId: string,
    params?: SaveStartDevicesDeviceIdSaveStartPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return saveStartDevicesDeviceIdSaveStartPostMutator<unknown>(
        getSaveStartDevicesDeviceIdSaveStartPostUrl(deviceId, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getSaveStartDevicesDeviceIdSaveStartPostMutationFetcher = (
    deviceId: string,
    params?: SaveStartDevicesDeviceIdSaveStartPostParams,
    options?: SecondParameter<typeof saveStartDevicesDeviceIdSaveStartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return saveStartDevicesDeviceIdSaveStartPost(deviceId, params, options);
    };
};
export const getSaveStartDevicesDeviceIdSaveStartPostMutationKey = (
    deviceId: string,
    params?: SaveStartDevicesDeviceIdSaveStartPostParams,
) => [`/devices/${deviceId}/save/start`, ...(params ? [params] : [])] as const;

export type SaveStartDevicesDeviceIdSaveStartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof saveStartDevicesDeviceIdSaveStartPost>>
>;
export type SaveStartDevicesDeviceIdSaveStartPostMutationError = HTTPValidationError;

/**
 * @summary Start saving data in current mode
 */
export const useSaveStartDevicesDeviceIdSaveStartPost = <TError = HTTPValidationError>(
    deviceId: string,
    params?: SaveStartDevicesDeviceIdSaveStartPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof saveStartDevicesDeviceIdSaveStartPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof saveStartDevicesDeviceIdSaveStartPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof saveStartDevicesDeviceIdSaveStartPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSaveStartDevicesDeviceIdSaveStartPostMutationKey(deviceId, params);
    const swrFn = getSaveStartDevicesDeviceIdSaveStartPostMutationFetcher(deviceId, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable saving data in current mode on device.
 * @summary Stop saving data in current mode
 */
export const getSaveStopDevicesDeviceIdSaveStopPostUrl = (deviceId: string) => {
    return `/devices/${deviceId}/save/stop`;
};

export const saveStopDevicesDeviceIdSaveStopPost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return saveStopDevicesDeviceIdSaveStopPostMutator<unknown>(getSaveStopDevicesDeviceIdSaveStopPostUrl(deviceId), {
        ...options,
        method: 'POST',
    });
};

export const getSaveStopDevicesDeviceIdSaveStopPostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof saveStopDevicesDeviceIdSaveStopPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return saveStopDevicesDeviceIdSaveStopPost(deviceId, options);
    };
};
export const getSaveStopDevicesDeviceIdSaveStopPostMutationKey = (deviceId: string) =>
    [`/devices/${deviceId}/save/stop`] as const;

export type SaveStopDevicesDeviceIdSaveStopPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof saveStopDevicesDeviceIdSaveStopPost>>
>;
export type SaveStopDevicesDeviceIdSaveStopPostMutationError = HTTPValidationError;

/**
 * @summary Stop saving data in current mode
 */
export const useSaveStopDevicesDeviceIdSaveStopPost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof saveStopDevicesDeviceIdSaveStopPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof saveStopDevicesDeviceIdSaveStopPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof saveStopDevicesDeviceIdSaveStopPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSaveStopDevicesDeviceIdSaveStopPostMutationKey(deviceId);
    const swrFn = getSaveStopDevicesDeviceIdSaveStopPostMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Restart all connected devices (soft reboot via UDP control).
 * @summary Restart all devices
 */
export const getRestartAllDevicesDevicesAllRestartPostUrl = () => {
    return `/devices/all/restart`;
};

export const restartAllDevicesDevicesAllRestartPost = async (options?: RequestInit): Promise<unknown> => {
    return restartAllDevicesDevicesAllRestartPostMutator<unknown>(getRestartAllDevicesDevicesAllRestartPostUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getRestartAllDevicesDevicesAllRestartPostMutationFetcher = (
    options?: SecondParameter<typeof restartAllDevicesDevicesAllRestartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return restartAllDevicesDevicesAllRestartPost(options);
    };
};
export const getRestartAllDevicesDevicesAllRestartPostMutationKey = () => [`/devices/all/restart`] as const;

export type RestartAllDevicesDevicesAllRestartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof restartAllDevicesDevicesAllRestartPost>>
>;
export type RestartAllDevicesDevicesAllRestartPostMutationError = unknown;

/**
 * @summary Restart all devices
 */
export const useRestartAllDevicesDevicesAllRestartPost = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof restartAllDevicesDevicesAllRestartPost>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof restartAllDevicesDevicesAllRestartPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof restartAllDevicesDevicesAllRestartPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getRestartAllDevicesDevicesAllRestartPostMutationKey();
    const swrFn = getRestartAllDevicesDevicesAllRestartPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Restart specified device (soft reboot via UDP control).
 * @summary Restart device
 */
export const getRestartDeviceDevicesDeviceIdRestartPostUrl = (deviceId: string) => {
    return `/devices/${deviceId}/restart`;
};

export const restartDeviceDevicesDeviceIdRestartPost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return restartDeviceDevicesDeviceIdRestartPostMutator<unknown>(
        getRestartDeviceDevicesDeviceIdRestartPostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getRestartDeviceDevicesDeviceIdRestartPostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof restartDeviceDevicesDeviceIdRestartPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return restartDeviceDevicesDeviceIdRestartPost(deviceId, options);
    };
};
export const getRestartDeviceDevicesDeviceIdRestartPostMutationKey = (deviceId: string) =>
    [`/devices/${deviceId}/restart`] as const;

export type RestartDeviceDevicesDeviceIdRestartPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof restartDeviceDevicesDeviceIdRestartPost>>
>;
export type RestartDeviceDevicesDeviceIdRestartPostMutationError = HTTPValidationError;

/**
 * @summary Restart device
 */
export const useRestartDeviceDevicesDeviceIdRestartPost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof restartDeviceDevicesDeviceIdRestartPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof restartDeviceDevicesDeviceIdRestartPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof restartDeviceDevicesDeviceIdRestartPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getRestartDeviceDevicesDeviceIdRestartPostMutationKey(deviceId);
    const swrFn = getRestartDeviceDevicesDeviceIdRestartPostMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Set factory device identity (device_id and mac address) via UDP control.
 * @summary Set device identity
 */
export const getSetDeviceIdentityDevicesDeviceIdSetIdentityPostUrl = (deviceId: string) => {
    return `/devices/${deviceId}/set-identity`;
};

export const setDeviceIdentityDevicesDeviceIdSetIdentityPost = async (
    deviceId: string,
    deviceIdentity: DeviceIdentity,
    options?: RequestInit,
): Promise<unknown> => {
    return setDeviceIdentityDevicesDeviceIdSetIdentityPostMutator<unknown>(
        getSetDeviceIdentityDevicesDeviceIdSetIdentityPostUrl(deviceId),
        {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(deviceIdentity),
        },
    );
};

export const getSetDeviceIdentityDevicesDeviceIdSetIdentityPostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof setDeviceIdentityDevicesDeviceIdSetIdentityPostMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceIdentity }) => {
        return setDeviceIdentityDevicesDeviceIdSetIdentityPost(deviceId, arg, options);
    };
};
export const getSetDeviceIdentityDevicesDeviceIdSetIdentityPostMutationKey = (deviceId: string) =>
    [`/devices/${deviceId}/set-identity`] as const;

export type SetDeviceIdentityDevicesDeviceIdSetIdentityPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof setDeviceIdentityDevicesDeviceIdSetIdentityPost>>
>;
export type SetDeviceIdentityDevicesDeviceIdSetIdentityPostMutationError = HTTPValidationError;

/**
 * @summary Set device identity
 */
export const useSetDeviceIdentityDevicesDeviceIdSetIdentityPost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof setDeviceIdentityDevicesDeviceIdSetIdentityPost>>,
            TError,
            Key,
            DeviceIdentity,
            Awaited<ReturnType<typeof setDeviceIdentityDevicesDeviceIdSetIdentityPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof setDeviceIdentityDevicesDeviceIdSetIdentityPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSetDeviceIdentityDevicesDeviceIdSetIdentityPostMutationKey(deviceId);
    const swrFn = getSetDeviceIdentityDevicesDeviceIdSetIdentityPostMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete all baseline files on device.
 * @summary Delete all baseline files
 */
export const getDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteUrl = (deviceId: string) => {
    return `/devices/${deviceId}/baseline/delete/all`;
};

export const deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDelete = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutator<unknown>(
        getDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteUrl(deviceId),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDelete(deviceId, options);
    };
};
export const getDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutationKey = (deviceId: string) =>
    [`/devices/${deviceId}/baseline/delete/all`] as const;

export type DeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDelete>>
>;
export type DeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete all baseline files
 */
export const useDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDelete = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDelete>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDelete>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutationKey(deviceId);
    const swrFn = getDeleteBaselineAllDevicesDeviceIdBaselineDeleteAllDeleteMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete a baseline file on device.
 * @summary Delete baseline file
 */
export const getDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteUrl = (
    deviceId: string,
    filename: string,
) => {
    return `/devices/${deviceId}/baseline/delete/${filename}`;
};

export const deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDelete = async (
    deviceId: string,
    filename: string,
    options?: RequestInit,
): Promise<unknown> => {
    return deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutator<unknown>(
        getDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteUrl(deviceId, filename),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutationFetcher = (
    deviceId: string,
    filename: string,
    options?: SecondParameter<typeof deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDelete(deviceId, filename, options);
    };
};
export const getDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutationKey = (
    deviceId: string,
    filename: string,
) => [`/devices/${deviceId}/baseline/delete/${filename}`] as const;

export type DeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDelete>>
>;
export type DeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete baseline file
 */
export const useDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDelete = <TError = HTTPValidationError>(
    deviceId: string,
    filename: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDelete>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDelete>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ??
        getDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutationKey(deviceId, filename);
    const swrFn = getDeleteBaselineFileDevicesDeviceIdBaselineDeleteFilenameDeleteMutationFetcher(
        deviceId,
        filename,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Clear all archive files from specified mode archive on the device.
 * @summary Clear archive files from device
 */
export const getDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteUrl = (
    deviceId: string,
    mode: 'sweep' | 'center',
) => {
    return `/devices/${deviceId}/archive/delete/${mode}/all`;
};

export const deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDelete = async (
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: RequestInit,
): Promise<unknown> => {
    return deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutator<unknown>(
        getDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteUrl(deviceId, mode),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutationFetcher = (
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: SecondParameter<typeof deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDelete(deviceId, mode, options);
    };
};
export const getDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutationKey = (
    deviceId: string,
    mode: 'sweep' | 'center',
) => [`/devices/${deviceId}/archive/delete/${mode}/all`] as const;

export type DeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDelete>>
>;
export type DeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutationError = HTTPValidationError;

/**
 * @summary Clear archive files from device
 */
export const useDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDelete = <TError = HTTPValidationError>(
    deviceId: string,
    mode: 'sweep' | 'center',
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDelete>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDelete>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ??
        getDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutationKey(deviceId, mode);
    const swrFn = getDeleteSweepArchiveAllDevicesDeviceIdArchiveDeleteModeAllDeleteMutationFetcher(
        deviceId,
        mode,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete a specific archive file on device.
 * @summary Delete archive file
 */
export const getDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteUrl = (
    deviceId: string,
    filename: string,
) => {
    return `/devices/${deviceId}/archive/delete/${filename}`;
};

export const deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDelete = async (
    deviceId: string,
    filename: string,
    options?: RequestInit,
): Promise<unknown> => {
    return deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutator<unknown>(
        getDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteUrl(deviceId, filename),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutationFetcher = (
    deviceId: string,
    filename: string,
    options?: SecondParameter<typeof deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDelete(deviceId, filename, options);
    };
};
export const getDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutationKey = (
    deviceId: string,
    filename: string,
) => [`/devices/${deviceId}/archive/delete/${filename}`] as const;

export type DeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDelete>>
>;
export type DeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete archive file
 */
export const useDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDelete = <TError = HTTPValidationError>(
    deviceId: string,
    filename: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDelete>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDelete>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof deleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ??
        getDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutationKey(deviceId, filename);
    const swrFn = getDeleteSweepArchiveFileDevicesDeviceIdArchiveDeleteFilenameDeleteMutationFetcher(
        deviceId,
        filename,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get connected IoT devices.
 * @summary List IoT devices
 */
export const getGetIotIotGetUrl = () => {
    return `/iot`;
};

export const getIotIotGet = async (options?: RequestInit): Promise<unknown> => {
    return getIotIotGetMutator<unknown>(getGetIotIotGetUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetIotIotGetKey = () => [`/iot`] as const;

export type GetIotIotGetQueryResult = NonNullable<Awaited<ReturnType<typeof getIotIotGet>>>;
export type GetIotIotGetQueryError = unknown;

/**
 * @summary List IoT devices
 */
export const useGetIotIotGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getIotIotGet>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof getIotIotGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetIotIotGetKey() : null));
    const swrFn = () => getIotIotGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get recent in-memory events for one IoT device.
 * @summary Get recent IoT device events
 */
export const getGetIotEventsIotIdEventsRecentGetUrl = (id: string, params?: GetIotEventsIotIdEventsRecentGetParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/iot/${id}/events/recent?${stringifiedParams}` : `/iot/${id}/events/recent`;
};

export const getIotEventsIotIdEventsRecentGet = async (
    id: string,
    params?: GetIotEventsIotIdEventsRecentGetParams,
    options?: RequestInit,
): Promise<unknown> => {
    return getIotEventsIotIdEventsRecentGetMutator<unknown>(getGetIotEventsIotIdEventsRecentGetUrl(id, params), {
        ...options,
        method: 'GET',
    });
};

export const getGetIotEventsIotIdEventsRecentGetKey = (id: string, params?: GetIotEventsIotIdEventsRecentGetParams) =>
    [`/iot/${id}/events/recent`, ...(params ? [params] : [])] as const;

export type GetIotEventsIotIdEventsRecentGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getIotEventsIotIdEventsRecentGet>>
>;
export type GetIotEventsIotIdEventsRecentGetQueryError = HTTPValidationError;

/**
 * @summary Get recent IoT device events
 */
export const useGetIotEventsIotIdEventsRecentGet = <TError = HTTPValidationError>(
    id: string,
    params?: GetIotEventsIotIdEventsRecentGetParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getIotEventsIotIdEventsRecentGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getIotEventsIotIdEventsRecentGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey =
        swrOptions?.swrKey ?? (() => (isEnabled ? getGetIotEventsIotIdEventsRecentGetKey(id, params) : null));
    const swrFn = () => getIotEventsIotIdEventsRecentGet(id, params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get persisted IoT event history for one device from SQLite.
 * @summary Get IoT device event history
 */
export const getGetIotEventHistoryIotIdEventsHistoryGetUrl = (
    id: string,
    params?: GetIotEventHistoryIotIdEventsHistoryGetParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/iot/${id}/events/history?${stringifiedParams}`
        : `/iot/${id}/events/history`;
};

export const getIotEventHistoryIotIdEventsHistoryGet = async (
    id: string,
    params?: GetIotEventHistoryIotIdEventsHistoryGetParams,
    options?: RequestInit,
): Promise<unknown> => {
    return getIotEventHistoryIotIdEventsHistoryGetMutator<unknown>(
        getGetIotEventHistoryIotIdEventsHistoryGetUrl(id, params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetIotEventHistoryIotIdEventsHistoryGetKey = (
    id: string,
    params?: GetIotEventHistoryIotIdEventsHistoryGetParams,
) => [`/iot/${id}/events/history`, ...(params ? [params] : [])] as const;

export type GetIotEventHistoryIotIdEventsHistoryGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getIotEventHistoryIotIdEventsHistoryGet>>
>;
export type GetIotEventHistoryIotIdEventsHistoryGetQueryError = HTTPValidationError;

/**
 * @summary Get IoT device event history
 */
export const useGetIotEventHistoryIotIdEventsHistoryGet = <TError = HTTPValidationError>(
    id: string,
    params?: GetIotEventHistoryIotIdEventsHistoryGetParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getIotEventHistoryIotIdEventsHistoryGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getIotEventHistoryIotIdEventsHistoryGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey =
        swrOptions?.swrKey ?? (() => (isEnabled ? getGetIotEventHistoryIotIdEventsHistoryGetKey(id, params) : null));
    const swrFn = () => getIotEventHistoryIotIdEventsHistoryGet(id, params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Fetch cached descriptor for one IoT device.
 * @summary Get IoT device descriptor
 */
export const getGetIotDescriptorIotIdDescriptorGetUrl = (id: string) => {
    return `/iot/${id}/descriptor`;
};

export const getIotDescriptorIotIdDescriptorGet = async (id: string, options?: RequestInit): Promise<unknown> => {
    return getIotDescriptorIotIdDescriptorGetMutator<unknown>(getGetIotDescriptorIotIdDescriptorGetUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getGetIotDescriptorIotIdDescriptorGetKey = (id: string) => [`/iot/${id}/descriptor`] as const;

export type GetIotDescriptorIotIdDescriptorGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getIotDescriptorIotIdDescriptorGet>>
>;
export type GetIotDescriptorIotIdDescriptorGetQueryError = HTTPValidationError;

/**
 * @summary Get IoT device descriptor
 */
export const useGetIotDescriptorIotIdDescriptorGet = <TError = HTTPValidationError>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getIotDescriptorIotIdDescriptorGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getIotDescriptorIotIdDescriptorGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetIotDescriptorIotIdDescriptorGetKey(id) : null));
    const swrFn = () => getIotDescriptorIotIdDescriptorGet(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get saved persistent bindings for all IoT devices.
 * @summary Get IoT bindings
 */
export const getGetIotBindingsIotBindingsGetUrl = () => {
    return `/iot/bindings`;
};

export const getIotBindingsIotBindingsGet = async (options?: RequestInit): Promise<unknown> => {
    return getIotBindingsIotBindingsGetMutator<unknown>(getGetIotBindingsIotBindingsGetUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetIotBindingsIotBindingsGetKey = () => [`/iot/bindings`] as const;

export type GetIotBindingsIotBindingsGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getIotBindingsIotBindingsGet>>
>;
export type GetIotBindingsIotBindingsGetQueryError = unknown;

/**
 * @summary Get IoT bindings
 */
export const useGetIotBindingsIotBindingsGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getIotBindingsIotBindingsGet>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getIotBindingsIotBindingsGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetIotBindingsIotBindingsGetKey() : null));
    const swrFn = () => getIotBindingsIotBindingsGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Read one DAC channel state. pin_ref may be the pin id, type, or color.
 * @summary Get IoT DAC state
 */
export const getGetIotDacStateIotIdDacPinRefGetUrl = (id: string, pinRef: string) => {
    return `/iot/${id}/dac/${pinRef}`;
};

export const getIotDacStateIotIdDacPinRefGet = async (
    id: string,
    pinRef: string,
    options?: RequestInit,
): Promise<unknown> => {
    return getIotDacStateIotIdDacPinRefGetMutator<unknown>(getGetIotDacStateIotIdDacPinRefGetUrl(id, pinRef), {
        ...options,
        method: 'GET',
    });
};

export const getGetIotDacStateIotIdDacPinRefGetKey = (id: string, pinRef: string) =>
    [`/iot/${id}/dac/${pinRef}`] as const;

export type GetIotDacStateIotIdDacPinRefGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getIotDacStateIotIdDacPinRefGet>>
>;
export type GetIotDacStateIotIdDacPinRefGetQueryError = HTTPValidationError;

/**
 * @summary Get IoT DAC state
 */
export const useGetIotDacStateIotIdDacPinRefGet = <TError = HTTPValidationError>(
    id: string,
    pinRef: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getIotDacStateIotIdDacPinRefGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getIotDacStateIotIdDacPinRefGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!(id && pinRef);
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetIotDacStateIotIdDacPinRefGetKey(id, pinRef) : null));
    const swrFn = () => getIotDacStateIotIdDacPinRefGet(id, pinRef, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Set one DAC channel. pin_ref may be the pin id, type, or color.
 * @summary Set IoT DAC value
 */
export const getSetIotDacValueIotIdDacPinRefPostUrl = (id: string, pinRef: string) => {
    return `/iot/${id}/dac/${pinRef}`;
};

export const setIotDacValueIotIdDacPinRefPost = async (
    id: string,
    pinRef: string,
    iotDacSetPayload: IotDacSetPayload,
    options?: RequestInit,
): Promise<unknown> => {
    return setIotDacValueIotIdDacPinRefPostMutator<unknown>(getSetIotDacValueIotIdDacPinRefPostUrl(id, pinRef), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(iotDacSetPayload),
    });
};

export const getSetIotDacValueIotIdDacPinRefPostMutationFetcher = (
    id: string,
    pinRef: string,
    options?: SecondParameter<typeof setIotDacValueIotIdDacPinRefPostMutator>,
) => {
    return (_: Key, { arg }: { arg: IotDacSetPayload }) => {
        return setIotDacValueIotIdDacPinRefPost(id, pinRef, arg, options);
    };
};
export const getSetIotDacValueIotIdDacPinRefPostMutationKey = (id: string, pinRef: string) =>
    [`/iot/${id}/dac/${pinRef}`] as const;

export type SetIotDacValueIotIdDacPinRefPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof setIotDacValueIotIdDacPinRefPost>>
>;
export type SetIotDacValueIotIdDacPinRefPostMutationError = HTTPValidationError;

/**
 * @summary Set IoT DAC value
 */
export const useSetIotDacValueIotIdDacPinRefPost = <TError = HTTPValidationError>(
    id: string,
    pinRef: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof setIotDacValueIotIdDacPinRefPost>>,
            TError,
            Key,
            IotDacSetPayload,
            Awaited<ReturnType<typeof setIotDacValueIotIdDacPinRefPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof setIotDacValueIotIdDacPinRefPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSetIotDacValueIotIdDacPinRefPostMutationKey(id, pinRef);
    const swrFn = getSetIotDacValueIotIdDacPinRefPostMutationFetcher(id, pinRef, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Zero all DAC outputs on the IoT device.
 * @summary Zero IoT DAC outputs
 */
export const getZeroIotDacIotIdDacZeroPostUrl = (id: string) => {
    return `/iot/${id}/dac/zero`;
};

export const zeroIotDacIotIdDacZeroPost = async (id: string, options?: RequestInit): Promise<unknown> => {
    return zeroIotDacIotIdDacZeroPostMutator<unknown>(getZeroIotDacIotIdDacZeroPostUrl(id), {
        ...options,
        method: 'POST',
    });
};

export const getZeroIotDacIotIdDacZeroPostMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof zeroIotDacIotIdDacZeroPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return zeroIotDacIotIdDacZeroPost(id, options);
    };
};
export const getZeroIotDacIotIdDacZeroPostMutationKey = (id: string) => [`/iot/${id}/dac/zero`] as const;

export type ZeroIotDacIotIdDacZeroPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof zeroIotDacIotIdDacZeroPost>>
>;
export type ZeroIotDacIotIdDacZeroPostMutationError = HTTPValidationError;

/**
 * @summary Zero IoT DAC outputs
 */
export const useZeroIotDacIotIdDacZeroPost = <TError = HTTPValidationError>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof zeroIotDacIotIdDacZeroPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof zeroIotDacIotIdDacZeroPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof zeroIotDacIotIdDacZeroPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getZeroIotDacIotIdDacZeroPostMutationKey(id);
    const swrFn = getZeroIotDacIotIdDacZeroPostMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Turn on multiple relays by logical pin ids, ordinal numbers, or colors.
 * @summary Turn on multiple IoT relays
 */
export const getIotRelaysOnIotIdRelaysOnPostUrl = (id: string, params: IotRelaysOnIotIdRelaysOnPostParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/iot/${id}/relays/on?${stringifiedParams}` : `/iot/${id}/relays/on`;
};

export const iotRelaysOnIotIdRelaysOnPost = async (
    id: string,
    iotSelectedPinsPayload: IotSelectedPinsPayload,
    params: IotRelaysOnIotIdRelaysOnPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return iotRelaysOnIotIdRelaysOnPostMutator<unknown>(getIotRelaysOnIotIdRelaysOnPostUrl(id, params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(iotSelectedPinsPayload),
    });
};

export const getIotRelaysOnIotIdRelaysOnPostMutationFetcher = (
    id: string,
    params: IotRelaysOnIotIdRelaysOnPostParams,
    options?: SecondParameter<typeof iotRelaysOnIotIdRelaysOnPostMutator>,
) => {
    return (_: Key, { arg }: { arg: IotSelectedPinsPayload }) => {
        return iotRelaysOnIotIdRelaysOnPost(id, arg, params, options);
    };
};
export const getIotRelaysOnIotIdRelaysOnPostMutationKey = (id: string, params: IotRelaysOnIotIdRelaysOnPostParams) =>
    [`/iot/${id}/relays/on`, ...(params ? [params] : [])] as const;

export type IotRelaysOnIotIdRelaysOnPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof iotRelaysOnIotIdRelaysOnPost>>
>;
export type IotRelaysOnIotIdRelaysOnPostMutationError = HTTPValidationError;

/**
 * @summary Turn on multiple IoT relays
 */
export const useIotRelaysOnIotIdRelaysOnPost = <TError = HTTPValidationError>(
    id: string,
    params: IotRelaysOnIotIdRelaysOnPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof iotRelaysOnIotIdRelaysOnPost>>,
            TError,
            Key,
            IotSelectedPinsPayload,
            Awaited<ReturnType<typeof iotRelaysOnIotIdRelaysOnPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof iotRelaysOnIotIdRelaysOnPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getIotRelaysOnIotIdRelaysOnPostMutationKey(id, params);
    const swrFn = getIotRelaysOnIotIdRelaysOnPostMutationFetcher(id, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Turn on a relay by logical pin id, ordinal number, or color.
 * @summary Turn on IoT relay
 */
export const getIotRelayOnIotIdRelayPinRefOnPostUrl = (
    id: string,
    pinRef: string,
    params: IotRelayOnIotIdRelayPinRefOnPostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/iot/${id}/relay/${pinRef}/on?${stringifiedParams}`
        : `/iot/${id}/relay/${pinRef}/on`;
};

export const iotRelayOnIotIdRelayPinRefOnPost = async (
    id: string,
    pinRef: string,
    params: IotRelayOnIotIdRelayPinRefOnPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return iotRelayOnIotIdRelayPinRefOnPostMutator<unknown>(
        getIotRelayOnIotIdRelayPinRefOnPostUrl(id, pinRef, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getIotRelayOnIotIdRelayPinRefOnPostMutationFetcher = (
    id: string,
    pinRef: string,
    params: IotRelayOnIotIdRelayPinRefOnPostParams,
    options?: SecondParameter<typeof iotRelayOnIotIdRelayPinRefOnPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return iotRelayOnIotIdRelayPinRefOnPost(id, pinRef, params, options);
    };
};
export const getIotRelayOnIotIdRelayPinRefOnPostMutationKey = (
    id: string,
    pinRef: string,
    params: IotRelayOnIotIdRelayPinRefOnPostParams,
) => [`/iot/${id}/relay/${pinRef}/on`, ...(params ? [params] : [])] as const;

export type IotRelayOnIotIdRelayPinRefOnPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof iotRelayOnIotIdRelayPinRefOnPost>>
>;
export type IotRelayOnIotIdRelayPinRefOnPostMutationError = HTTPValidationError;

/**
 * @summary Turn on IoT relay
 */
export const useIotRelayOnIotIdRelayPinRefOnPost = <TError = HTTPValidationError>(
    id: string,
    pinRef: string,
    params: IotRelayOnIotIdRelayPinRefOnPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof iotRelayOnIotIdRelayPinRefOnPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof iotRelayOnIotIdRelayPinRefOnPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof iotRelayOnIotIdRelayPinRefOnPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getIotRelayOnIotIdRelayPinRefOnPostMutationKey(id, pinRef, params);
    const swrFn = getIotRelayOnIotIdRelayPinRefOnPostMutationFetcher(id, pinRef, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Turn off a relay by logical pin id, ordinal number, or color.
 * @summary Turn off IoT relay
 */
export const getIotRelayOffIotIdRelayPinRefOffPostUrl = (
    id: string,
    pinRef: string,
    params: IotRelayOffIotIdRelayPinRefOffPostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/iot/${id}/relay/${pinRef}/off?${stringifiedParams}`
        : `/iot/${id}/relay/${pinRef}/off`;
};

export const iotRelayOffIotIdRelayPinRefOffPost = async (
    id: string,
    pinRef: string,
    params: IotRelayOffIotIdRelayPinRefOffPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return iotRelayOffIotIdRelayPinRefOffPostMutator<unknown>(
        getIotRelayOffIotIdRelayPinRefOffPostUrl(id, pinRef, params),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getIotRelayOffIotIdRelayPinRefOffPostMutationFetcher = (
    id: string,
    pinRef: string,
    params: IotRelayOffIotIdRelayPinRefOffPostParams,
    options?: SecondParameter<typeof iotRelayOffIotIdRelayPinRefOffPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return iotRelayOffIotIdRelayPinRefOffPost(id, pinRef, params, options);
    };
};
export const getIotRelayOffIotIdRelayPinRefOffPostMutationKey = (
    id: string,
    pinRef: string,
    params: IotRelayOffIotIdRelayPinRefOffPostParams,
) => [`/iot/${id}/relay/${pinRef}/off`, ...(params ? [params] : [])] as const;

export type IotRelayOffIotIdRelayPinRefOffPostMutationResult = NonNullable<
    Awaited<ReturnType<typeof iotRelayOffIotIdRelayPinRefOffPost>>
>;
export type IotRelayOffIotIdRelayPinRefOffPostMutationError = HTTPValidationError;

/**
 * @summary Turn off IoT relay
 */
export const useIotRelayOffIotIdRelayPinRefOffPost = <TError = HTTPValidationError>(
    id: string,
    pinRef: string,
    params: IotRelayOffIotIdRelayPinRefOffPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof iotRelayOffIotIdRelayPinRefOffPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof iotRelayOffIotIdRelayPinRefOffPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof iotRelayOffIotIdRelayPinRefOffPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getIotRelayOffIotIdRelayPinRefOffPostMutationKey(id, pinRef, params);
    const swrFn = getIotRelayOffIotIdRelayPinRefOffPostMutationFetcher(id, pinRef, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Set bindings for a specific IoT relay pin. The payload should include the ID of the device to bind to, and optionally a label and kind for the binding.
 * @summary Set IoT relay pin bindings
 */
export const getSaveIotBindingIotBindingsIdPinIdPutUrl = (id: string, pinId: string) => {
    return `/iot/bindings/${id}/${pinId}`;
};

export const saveIotBindingIotBindingsIdPinIdPut = async (
    id: string,
    pinId: string,
    iotPinBindingPayload: IotPinBindingPayload,
    options?: RequestInit,
): Promise<unknown> => {
    return saveIotBindingIotBindingsIdPinIdPutMutator<unknown>(getSaveIotBindingIotBindingsIdPinIdPutUrl(id, pinId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(iotPinBindingPayload),
    });
};

export const getSaveIotBindingIotBindingsIdPinIdPutMutationFetcher = (
    id: string,
    pinId: string,
    options?: SecondParameter<typeof saveIotBindingIotBindingsIdPinIdPutMutator>,
) => {
    return (_: Key, { arg }: { arg: IotPinBindingPayload }) => {
        return saveIotBindingIotBindingsIdPinIdPut(id, pinId, arg, options);
    };
};
export const getSaveIotBindingIotBindingsIdPinIdPutMutationKey = (id: string, pinId: string) =>
    [`/iot/bindings/${id}/${pinId}`] as const;

export type SaveIotBindingIotBindingsIdPinIdPutMutationResult = NonNullable<
    Awaited<ReturnType<typeof saveIotBindingIotBindingsIdPinIdPut>>
>;
export type SaveIotBindingIotBindingsIdPinIdPutMutationError = HTTPValidationError;

/**
 * @summary Set IoT relay pin bindings
 */
export const useSaveIotBindingIotBindingsIdPinIdPut = <TError = HTTPValidationError>(
    id: string,
    pinId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof saveIotBindingIotBindingsIdPinIdPut>>,
            TError,
            Key,
            IotPinBindingPayload,
            Awaited<ReturnType<typeof saveIotBindingIotBindingsIdPinIdPut>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof saveIotBindingIotBindingsIdPinIdPutMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSaveIotBindingIotBindingsIdPinIdPutMutationKey(id, pinId);
    const swrFn = getSaveIotBindingIotBindingsIdPinIdPutMutationFetcher(id, pinId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Delete one persistent binding for an IoT logical pin.
 * @summary Delete IoT relay pin binding
 */
export const getRemoveIotBindingIotBindingsIdPinIdDeleteUrl = (id: string, pinId: string) => {
    return `/iot/bindings/${id}/${pinId}`;
};

export const removeIotBindingIotBindingsIdPinIdDelete = async (
    id: string,
    pinId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return removeIotBindingIotBindingsIdPinIdDeleteMutator<unknown>(
        getRemoveIotBindingIotBindingsIdPinIdDeleteUrl(id, pinId),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getRemoveIotBindingIotBindingsIdPinIdDeleteMutationFetcher = (
    id: string,
    pinId: string,
    options?: SecondParameter<typeof removeIotBindingIotBindingsIdPinIdDeleteMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return removeIotBindingIotBindingsIdPinIdDelete(id, pinId, options);
    };
};
export const getRemoveIotBindingIotBindingsIdPinIdDeleteMutationKey = (id: string, pinId: string) =>
    [`/iot/bindings/${id}/${pinId}`] as const;

export type RemoveIotBindingIotBindingsIdPinIdDeleteMutationResult = NonNullable<
    Awaited<ReturnType<typeof removeIotBindingIotBindingsIdPinIdDelete>>
>;
export type RemoveIotBindingIotBindingsIdPinIdDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete IoT relay pin binding
 */
export const useRemoveIotBindingIotBindingsIdPinIdDelete = <TError = HTTPValidationError>(
    id: string,
    pinId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof removeIotBindingIotBindingsIdPinIdDelete>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof removeIotBindingIotBindingsIdPinIdDelete>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof removeIotBindingIotBindingsIdPinIdDeleteMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getRemoveIotBindingIotBindingsIdPinIdDeleteMutationKey(id, pinId);
    const swrFn = getRemoveIotBindingIotBindingsIdPinIdDeleteMutationFetcher(id, pinId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get the saved layout map (reference + coords).
 * @summary Get layout map
 */
export const getGetLayoutMapLayoutGetUrl = () => {
    return `/layout`;
};

export const getLayoutMapLayoutGet = async (options?: RequestInit): Promise<unknown> => {
    return getLayoutMapLayoutGetMutator<unknown>(getGetLayoutMapLayoutGetUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetLayoutMapLayoutGetKey = () => [`/layout`] as const;

export type GetLayoutMapLayoutGetQueryResult = NonNullable<Awaited<ReturnType<typeof getLayoutMapLayoutGet>>>;
export type GetLayoutMapLayoutGetQueryError = unknown;

/**
 * @summary Get layout map
 */
export const useGetLayoutMapLayoutGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getLayoutMapLayoutGet>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getLayoutMapLayoutGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetLayoutMapLayoutGetKey() : null));
    const swrFn = () => getLayoutMapLayoutGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Save/replace the layout map and apply to heartbeat registry
 * @summary Save layout map
 */
export const getSaveLayoutMapLayoutPostUrl = () => {
    return `/layout`;
};

export const saveLayoutMapLayoutPost = async (layoutMap: LayoutMap, options?: RequestInit): Promise<unknown> => {
    return saveLayoutMapLayoutPostMutator<unknown>(getSaveLayoutMapLayoutPostUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(layoutMap),
    });
};

export const getSaveLayoutMapLayoutPostMutationFetcher = (
    options?: SecondParameter<typeof saveLayoutMapLayoutPostMutator>,
) => {
    return (_: Key, { arg }: { arg: LayoutMap }) => {
        return saveLayoutMapLayoutPost(arg, options);
    };
};
export const getSaveLayoutMapLayoutPostMutationKey = () => [`/layout`] as const;

export type SaveLayoutMapLayoutPostMutationResult = NonNullable<Awaited<ReturnType<typeof saveLayoutMapLayoutPost>>>;
export type SaveLayoutMapLayoutPostMutationError = HTTPValidationError;

/**
 * @summary Save layout map
 */
export const useSaveLayoutMapLayoutPost = <TError = HTTPValidationError>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof saveLayoutMapLayoutPost>>,
        TError,
        Key,
        LayoutMap,
        Awaited<ReturnType<typeof saveLayoutMapLayoutPost>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof saveLayoutMapLayoutPostMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getSaveLayoutMapLayoutPostMutationKey();
    const swrFn = getSaveLayoutMapLayoutPostMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get latest firmware metadata
 * @summary Get latest firmware metadata
 */
export const getGetLatestFirmwareOtaLatestGetUrl = () => {
    return `/ota/latest`;
};

export const getLatestFirmwareOtaLatestGet = async (options?: RequestInit): Promise<unknown> => {
    return getLatestFirmwareOtaLatestGetMutator<unknown>(getGetLatestFirmwareOtaLatestGetUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getGetLatestFirmwareOtaLatestGetKey = () => [`/ota/latest`] as const;

export type GetLatestFirmwareOtaLatestGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getLatestFirmwareOtaLatestGet>>
>;
export type GetLatestFirmwareOtaLatestGetQueryError = unknown;

/**
 * @summary Get latest firmware metadata
 */
export const useGetLatestFirmwareOtaLatestGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getLatestFirmwareOtaLatestGet>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof getLatestFirmwareOtaLatestGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getGetLatestFirmwareOtaLatestGetKey() : null));
    const swrFn = () => getLatestFirmwareOtaLatestGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Push OTA update command to device
 * @summary Push OTA update command
 */
export const getOtaPushAllOtaPushPostUrl = (params?: OtaPushAllOtaPushPostParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/ota/push?${stringifiedParams}` : `/ota/push`;
};

export const otaPushAllOtaPushPost = async (
    params?: OtaPushAllOtaPushPostParams,
    options?: RequestInit,
): Promise<unknown> => {
    return otaPushAllOtaPushPostMutator<unknown>(getOtaPushAllOtaPushPostUrl(params), {
        ...options,
        method: 'POST',
    });
};

export const getOtaPushAllOtaPushPostMutationFetcher = (
    params?: OtaPushAllOtaPushPostParams,
    options?: SecondParameter<typeof otaPushAllOtaPushPostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return otaPushAllOtaPushPost(params, options);
    };
};
export const getOtaPushAllOtaPushPostMutationKey = (params?: OtaPushAllOtaPushPostParams) =>
    [`/ota/push`, ...(params ? [params] : [])] as const;

export type OtaPushAllOtaPushPostMutationResult = NonNullable<Awaited<ReturnType<typeof otaPushAllOtaPushPost>>>;
export type OtaPushAllOtaPushPostMutationError = HTTPValidationError;

/**
 * @summary Push OTA update command
 */
export const useOtaPushAllOtaPushPost = <TError = HTTPValidationError>(
    params?: OtaPushAllOtaPushPostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof otaPushAllOtaPushPost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof otaPushAllOtaPushPost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof otaPushAllOtaPushPostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getOtaPushAllOtaPushPostMutationKey(params);
    const swrFn = getOtaPushAllOtaPushPostMutationFetcher(params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get list of available antenna datasets
 * @summary List antenna datasets
 */
export const getManifestCompensationAntennasManifestGetUrl = () => {
    return `/compensation/antennas/manifest`;
};

export const manifestCompensationAntennasManifestGet = async (options?: RequestInit): Promise<unknown> => {
    return manifestCompensationAntennasManifestGetMutator<unknown>(getManifestCompensationAntennasManifestGetUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getManifestCompensationAntennasManifestGetKey = () => [`/compensation/antennas/manifest`] as const;

export type ManifestCompensationAntennasManifestGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof manifestCompensationAntennasManifestGet>>
>;
export type ManifestCompensationAntennasManifestGetQueryError = unknown;

/**
 * @summary List antenna datasets
 */
export const useManifestCompensationAntennasManifestGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof manifestCompensationAntennasManifestGet>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof manifestCompensationAntennasManifestGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getManifestCompensationAntennasManifestGetKey() : null));
    const swrFn = () => manifestCompensationAntennasManifestGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get antenna dataset in JSON format
 * @summary Get antenna dataset (JSON)
 */
export const getAntennaJsonCompensationAntennasDataAntennaIdJsonGetUrl = (antennaId: string) => {
    return `/compensation/antennas/data/${antennaId}.json`;
};

export const antennaJsonCompensationAntennasDataAntennaIdJsonGet = async (
    antennaId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return antennaJsonCompensationAntennasDataAntennaIdJsonGetMutator<unknown>(
        getAntennaJsonCompensationAntennasDataAntennaIdJsonGetUrl(antennaId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAntennaJsonCompensationAntennasDataAntennaIdJsonGetKey = (antennaId: string) =>
    [`/compensation/antennas/data/${antennaId}.json`] as const;

export type AntennaJsonCompensationAntennasDataAntennaIdJsonGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof antennaJsonCompensationAntennasDataAntennaIdJsonGet>>
>;
export type AntennaJsonCompensationAntennasDataAntennaIdJsonGetQueryError = HTTPValidationError;

/**
 * @summary Get antenna dataset (JSON)
 */
export const useAntennaJsonCompensationAntennasDataAntennaIdJsonGet = <TError = HTTPValidationError>(
    antennaId: string,
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof antennaJsonCompensationAntennasDataAntennaIdJsonGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof antennaJsonCompensationAntennasDataAntennaIdJsonGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!antennaId;
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getAntennaJsonCompensationAntennasDataAntennaIdJsonGetKey(antennaId) : null));
    const swrFn = () => antennaJsonCompensationAntennasDataAntennaIdJsonGet(antennaId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get antenna dataset in binary format
 * @summary Get antenna dataset (binary)
 */
export const getAntennaBinCompensationAntennasDataAntennaIdBinGetUrl = (antennaId: string) => {
    return `/compensation/antennas/data/${antennaId}.bin`;
};

export const antennaBinCompensationAntennasDataAntennaIdBinGet = async (
    antennaId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return antennaBinCompensationAntennasDataAntennaIdBinGetMutator<unknown>(
        getAntennaBinCompensationAntennasDataAntennaIdBinGetUrl(antennaId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAntennaBinCompensationAntennasDataAntennaIdBinGetKey = (antennaId: string) =>
    [`/compensation/antennas/data/${antennaId}.bin`] as const;

export type AntennaBinCompensationAntennasDataAntennaIdBinGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof antennaBinCompensationAntennasDataAntennaIdBinGet>>
>;
export type AntennaBinCompensationAntennasDataAntennaIdBinGetQueryError = HTTPValidationError;

/**
 * @summary Get antenna dataset (binary)
 */
export const useAntennaBinCompensationAntennasDataAntennaIdBinGet = <TError = HTTPValidationError>(
    antennaId: string,
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof antennaBinCompensationAntennasDataAntennaIdBinGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<typeof antennaBinCompensationAntennasDataAntennaIdBinGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!antennaId;
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getAntennaBinCompensationAntennasDataAntennaIdBinGetKey(antennaId) : null));
    const swrFn = () => antennaBinCompensationAntennasDataAntennaIdBinGet(antennaId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Get current antenna data on the specified device.
 * @summary Get device antenna info
 */
export const getGetDeviceAntennasCompensationDeviceIdAntennasGetUrl = (deviceId: string) => {
    return `/compensation/${deviceId}/antennas`;
};

export const getDeviceAntennasCompensationDeviceIdAntennasGet = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return getDeviceAntennasCompensationDeviceIdAntennasGetMutator<unknown>(
        getGetDeviceAntennasCompensationDeviceIdAntennasGetUrl(deviceId),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getGetDeviceAntennasCompensationDeviceIdAntennasGetKey = (deviceId: string) =>
    [`/compensation/${deviceId}/antennas`] as const;

export type GetDeviceAntennasCompensationDeviceIdAntennasGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDeviceAntennasCompensationDeviceIdAntennasGet>>
>;
export type GetDeviceAntennasCompensationDeviceIdAntennasGetQueryError = HTTPValidationError;

/**
 * @summary Get device antenna info
 */
export const useGetDeviceAntennasCompensationDeviceIdAntennasGet = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof getDeviceAntennasCompensationDeviceIdAntennasGet>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof getDeviceAntennasCompensationDeviceIdAntennasGetMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!deviceId;
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getGetDeviceAntennasCompensationDeviceIdAntennasGetKey(deviceId) : null));
    const swrFn = () => getDeviceAntennasCompensationDeviceIdAntennasGet(deviceId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable VSWR compensation on the specified device.
 * @summary Enable VSWR compensation
 */
export const getEnableVswrCompensationCompensationDeviceIdVswrEnablePostUrl = (deviceId: string) => {
    return `/compensation/${deviceId}/vswr/enable`;
};

export const enableVswrCompensationCompensationDeviceIdVswrEnablePost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return enableVswrCompensationCompensationDeviceIdVswrEnablePostMutator<unknown>(
        getEnableVswrCompensationCompensationDeviceIdVswrEnablePostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getEnableVswrCompensationCompensationDeviceIdVswrEnablePostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof enableVswrCompensationCompensationDeviceIdVswrEnablePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return enableVswrCompensationCompensationDeviceIdVswrEnablePost(deviceId, options);
    };
};
export const getEnableVswrCompensationCompensationDeviceIdVswrEnablePostMutationKey = (deviceId: string) =>
    [`/compensation/${deviceId}/vswr/enable`] as const;

export type EnableVswrCompensationCompensationDeviceIdVswrEnablePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof enableVswrCompensationCompensationDeviceIdVswrEnablePost>>
>;
export type EnableVswrCompensationCompensationDeviceIdVswrEnablePostMutationError = HTTPValidationError;

/**
 * @summary Enable VSWR compensation
 */
export const useEnableVswrCompensationCompensationDeviceIdVswrEnablePost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof enableVswrCompensationCompensationDeviceIdVswrEnablePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof enableVswrCompensationCompensationDeviceIdVswrEnablePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof enableVswrCompensationCompensationDeviceIdVswrEnablePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getEnableVswrCompensationCompensationDeviceIdVswrEnablePostMutationKey(deviceId);
    const swrFn = getEnableVswrCompensationCompensationDeviceIdVswrEnablePostMutationFetcher(deviceId, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable VSWR compensation on the specified device.
 * @summary Disable VSWR compensation
 */
export const getDisableVswrCompensationCompensationDeviceIdVswrDisablePostUrl = (deviceId: string) => {
    return `/compensation/${deviceId}/vswr/disable`;
};

export const disableVswrCompensationCompensationDeviceIdVswrDisablePost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return disableVswrCompensationCompensationDeviceIdVswrDisablePostMutator<unknown>(
        getDisableVswrCompensationCompensationDeviceIdVswrDisablePostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getDisableVswrCompensationCompensationDeviceIdVswrDisablePostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof disableVswrCompensationCompensationDeviceIdVswrDisablePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return disableVswrCompensationCompensationDeviceIdVswrDisablePost(deviceId, options);
    };
};
export const getDisableVswrCompensationCompensationDeviceIdVswrDisablePostMutationKey = (deviceId: string) =>
    [`/compensation/${deviceId}/vswr/disable`] as const;

export type DisableVswrCompensationCompensationDeviceIdVswrDisablePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof disableVswrCompensationCompensationDeviceIdVswrDisablePost>>
>;
export type DisableVswrCompensationCompensationDeviceIdVswrDisablePostMutationError = HTTPValidationError;

/**
 * @summary Disable VSWR compensation
 */
export const useDisableVswrCompensationCompensationDeviceIdVswrDisablePost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof disableVswrCompensationCompensationDeviceIdVswrDisablePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof disableVswrCompensationCompensationDeviceIdVswrDisablePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof disableVswrCompensationCompensationDeviceIdVswrDisablePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getDisableVswrCompensationCompensationDeviceIdVswrDisablePostMutationKey(deviceId);
    const swrFn = getDisableVswrCompensationCompensationDeviceIdVswrDisablePostMutationFetcher(
        deviceId,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable noise figure compensation on the specified device.
 * @summary Enable noise figure compensation
 */
export const getEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostUrl = (deviceId: string) => {
    return `/compensation/${deviceId}/noise-figure/enable`;
};

export const enableNfCompensationCompensationDeviceIdNoiseFigureEnablePost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return enableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutator<unknown>(
        getEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof enableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return enableNfCompensationCompensationDeviceIdNoiseFigureEnablePost(deviceId, options);
    };
};
export const getEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutationKey = (deviceId: string) =>
    [`/compensation/${deviceId}/noise-figure/enable`] as const;

export type EnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof enableNfCompensationCompensationDeviceIdNoiseFigureEnablePost>>
>;
export type EnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutationError = HTTPValidationError;

/**
 * @summary Enable noise figure compensation
 */
export const useEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof enableNfCompensationCompensationDeviceIdNoiseFigureEnablePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof enableNfCompensationCompensationDeviceIdNoiseFigureEnablePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof enableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutationKey(deviceId);
    const swrFn = getEnableNfCompensationCompensationDeviceIdNoiseFigureEnablePostMutationFetcher(
        deviceId,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable noise figure compensation on the specified device.
 * @summary Disable noise figure compensation
 */
export const getDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostUrl = (deviceId: string) => {
    return `/compensation/${deviceId}/noise-figure/disable`;
};

export const disableNfCompensationCompensationDeviceIdNoiseFigureDisablePost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return disableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutator<unknown>(
        getDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<typeof disableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return disableNfCompensationCompensationDeviceIdNoiseFigureDisablePost(deviceId, options);
    };
};
export const getDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutationKey = (deviceId: string) =>
    [`/compensation/${deviceId}/noise-figure/disable`] as const;

export type DisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof disableNfCompensationCompensationDeviceIdNoiseFigureDisablePost>>
>;
export type DisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutationError = HTTPValidationError;

/**
 * @summary Disable noise figure compensation
 */
export const useDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePost = <TError = HTTPValidationError>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof disableNfCompensationCompensationDeviceIdNoiseFigureDisablePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof disableNfCompensationCompensationDeviceIdNoiseFigureDisablePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof disableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutationKey(deviceId);
    const swrFn = getDisableNfCompensationCompensationDeviceIdNoiseFigureDisablePostMutationFetcher(
        deviceId,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Enable temperature compensation on the specified device.
 * @summary Enable temperature compensation
 */
export const getEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostUrl = (deviceId: string) => {
    return `/compensation/${deviceId}/use-rf-temperature/enable`;
};

export const enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutator<unknown>(
        getEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<
        typeof enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutator
    >,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePost(deviceId, options);
    };
};
export const getEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutationKey = (
    deviceId: string,
) => [`/compensation/${deviceId}/use-rf-temperature/enable`] as const;

export type EnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePost>>
>;
export type EnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutationError =
    HTTPValidationError;

/**
 * @summary Enable temperature compensation
 */
export const useEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePost = <
    TError = HTTPValidationError,
>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePost>>
        > & { swrKey?: string };
        request?: SecondParameter<
            typeof enableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutator
        >;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ??
        getEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutationKey(deviceId);
    const swrFn = getEnableTemperatureCompensationCompensationDeviceIdUseRfTemperatureEnablePostMutationFetcher(
        deviceId,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Disable temperature compensation on the specified device.
 * @summary Disable temperature compensation
 */
export const getDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostUrl = (
    deviceId: string,
) => {
    return `/compensation/${deviceId}/use-rf-temperature/disable`;
};

export const disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePost = async (
    deviceId: string,
    options?: RequestInit,
): Promise<unknown> => {
    return disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutator<unknown>(
        getDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostUrl(deviceId),
        {
            ...options,
            method: 'POST',
        },
    );
};

export const getDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutationFetcher = (
    deviceId: string,
    options?: SecondParameter<
        typeof disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutator
    >,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePost(deviceId, options);
    };
};
export const getDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutationKey = (
    deviceId: string,
) => [`/compensation/${deviceId}/use-rf-temperature/disable`] as const;

export type DisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePost>>
>;
export type DisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutationError =
    HTTPValidationError;

/**
 * @summary Disable temperature compensation
 */
export const useDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePost = <
    TError = HTTPValidationError,
>(
    deviceId: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePost>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePost>>
        > & { swrKey?: string };
        request?: SecondParameter<
            typeof disableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutator
        >;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ??
        getDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutationKey(deviceId);
    const swrFn = getDisableTemperatureCompensationCompensationDeviceIdUseRfTemperatureDisablePostMutationFetcher(
        deviceId,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Download a ZIP file containing all PDFs and a summary Excel file.
 * @summary Download a ZIP bundle of all measurement reports with an accompanying summary Excel file
 */
export const getDownloadMeasurementReportSummaryDocumentsDownloadSummaryGetUrl = () => {
    return `/documents/download-summary`;
};

export const downloadMeasurementReportSummaryDocumentsDownloadSummaryGet = async (
    options?: RequestInit,
): Promise<unknown> => {
    return downloadMeasurementReportSummaryDocumentsDownloadSummaryGetMutator<unknown>(
        getDownloadMeasurementReportSummaryDocumentsDownloadSummaryGetUrl(),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getDownloadMeasurementReportSummaryDocumentsDownloadSummaryGetKey = () =>
    [`/documents/download-summary`] as const;

export type DownloadMeasurementReportSummaryDocumentsDownloadSummaryGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof downloadMeasurementReportSummaryDocumentsDownloadSummaryGet>>
>;
export type DownloadMeasurementReportSummaryDocumentsDownloadSummaryGetQueryError = unknown;

/**
 * @summary Download a ZIP bundle of all measurement reports with an accompanying summary Excel file
 */
export const useDownloadMeasurementReportSummaryDocumentsDownloadSummaryGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<
        Awaited<ReturnType<typeof downloadMeasurementReportSummaryDocumentsDownloadSummaryGet>>,
        TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof downloadMeasurementReportSummaryDocumentsDownloadSummaryGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getDownloadMeasurementReportSummaryDocumentsDownloadSummaryGetKey() : null));
    const swrFn = () => downloadMeasurementReportSummaryDocumentsDownloadSummaryGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Return a list of uploaded measurement reports.
 * @summary List uploaded frequency measurement reports
 */
export const getListMeasurementReportsDocumentsMeasurementReportsListGetUrl = () => {
    return `/documents/measurement-reports/list`;
};

export const listMeasurementReportsDocumentsMeasurementReportsListGet = async (
    options?: RequestInit,
): Promise<unknown> => {
    return listMeasurementReportsDocumentsMeasurementReportsListGetMutator<unknown>(
        getListMeasurementReportsDocumentsMeasurementReportsListGetUrl(),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getListMeasurementReportsDocumentsMeasurementReportsListGetKey = () =>
    [`/documents/measurement-reports/list`] as const;

export type ListMeasurementReportsDocumentsMeasurementReportsListGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof listMeasurementReportsDocumentsMeasurementReportsListGet>>
>;
export type ListMeasurementReportsDocumentsMeasurementReportsListGetQueryError = unknown;

/**
 * @summary List uploaded frequency measurement reports
 */
export const useListMeasurementReportsDocumentsMeasurementReportsListGet = <TError = unknown>(options?: {
    swr?: SWRConfiguration<
        Awaited<ReturnType<typeof listMeasurementReportsDocumentsMeasurementReportsListGet>>,
        TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof listMeasurementReportsDocumentsMeasurementReportsListGetMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey =
        swrOptions?.swrKey ??
        (() => (isEnabled ? getListMeasurementReportsDocumentsMeasurementReportsListGetKey() : null));
    const swrFn = () => listMeasurementReportsDocumentsMeasurementReportsListGet(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Download a single PDF by filename. Searches across all date subdirectories.
 * @summary Download a measurement report PDF
 */
export const getDownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetUrl = (filename: string) => {
    return `/documents/measurement-reports/download/${filename}`;
};

export const downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGet = async (
    filename: string,
    options?: RequestInit,
): Promise<unknown> => {
    return downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetMutator<unknown>(
        getDownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetUrl(filename),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getDownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetKey = (filename: string) =>
    [`/documents/measurement-reports/download/${filename}`] as const;

export type DownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGet>>
>;
export type DownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetQueryError = HTTPValidationError;

/**
 * @summary Download a measurement report PDF
 */
export const useDownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGet = <
    TError = HTTPValidationError,
>(
    filename: string,
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<
            typeof downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetMutator
        >;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!filename;
    const swrKey =
        swrOptions?.swrKey ??
        (() =>
            isEnabled ? getDownloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGetKey(filename) : null);
    const swrFn = () =>
        downloadMeasurementReportDocumentsMeasurementReportsDownloadFilenameGet(filename, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Download a ZIP file containing all PDFs for the specified date (YYYY-MM-DD).
 * @summary Download a ZIP bundle of measurement reports for a specific date
 */
export const getDownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetUrl = (date: string) => {
    return `/documents/measurement-reports/download-bundle/${date}`;
};

export const downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGet = async (
    date: string,
    options?: RequestInit,
): Promise<unknown> => {
    return downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetMutator<unknown>(
        getDownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetUrl(date),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getDownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetKey = (date: string) =>
    [`/documents/measurement-reports/download-bundle/${date}`] as const;

export type DownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGet>>
>;
export type DownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetQueryError =
    HTTPValidationError;

/**
 * @summary Download a ZIP bundle of measurement reports for a specific date
 */
export const useDownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGet = <
    TError = HTTPValidationError,
>(
    date: string,
    options?: {
        swr?: SWRConfiguration<
            Awaited<ReturnType<typeof downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGet>>,
            TError
        > & { swrKey?: Key; enabled?: boolean };
        request?: SecondParameter<
            typeof downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetMutator
        >;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!date;
    const swrKey =
        swrOptions?.swrKey ??
        (() =>
            isEnabled
                ? getDownloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGetKey(date)
                : null);
    const swrFn = () =>
        downloadMeasurementReportBundleDocumentsMeasurementReportsDownloadBundleDateGet(date, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Accept one PDF and save it under /data/measurement_reports/{date}/{filename}.
 * @summary Upload a frequency measurement report PDF
 */
export const getUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostUrl = (
    params?: UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/documents/measurement-reports/upload/single?${stringifiedParams}`
        : `/documents/measurement-reports/upload/single`;
};

export const uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost = async (
    bodyUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost: BodyUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost,
    params?: UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostParams,
    options?: RequestInit,
): Promise<unknown> => {
    const formData = new FormData();
    formData.append(`file`, bodyUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost.file);

    return uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutator<unknown>(
        getUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostUrl(params),
        {
            ...options,
            method: 'POST',
            body: formData,
        },
    );
};

export const getUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutationFetcher = (
    params?: UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostParams,
    options?: SecondParameter<typeof uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutator>,
) => {
    return (_: Key, { arg }: { arg: BodyUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost }) => {
        return uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost(arg, params, options);
    };
};
export const getUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutationKey = (
    params?: UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostParams,
) => [`/documents/measurement-reports/upload/single`, ...(params ? [params] : [])] as const;

export type UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost>>
>;
export type UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutationError = HTTPValidationError;

/**
 * @summary Upload a frequency measurement report PDF
 */
export const useUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost = <TError = HTTPValidationError>(
    params?: UploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost>>,
            TError,
            Key,
            BodyUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost,
            Awaited<ReturnType<typeof uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePost>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof uploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ?? getUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutationKey(params);
    const swrFn = getUploadMeasurementReportDocumentsMeasurementReportsUploadSinglePostMutationFetcher(
        params,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Accepts a .zip file containing PDFs matching the naming convention. Distributes each to its correct date subdirectory.
 * @summary Upload a ZIP bundle of frequency measurement report PDFs
 */
export const getUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostUrl = (
    params?: UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/documents/measurement-reports/upload/bundle?${stringifiedParams}`
        : `/documents/measurement-reports/upload/bundle`;
};

export const uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost = async (
    bodyUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost: BodyUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost,
    params?: UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostParams,
    options?: RequestInit,
): Promise<unknown> => {
    const formData = new FormData();
    formData.append(`file`, bodyUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost.file);

    return uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutator<unknown>(
        getUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostUrl(params),
        {
            ...options,
            method: 'POST',
            body: formData,
        },
    );
};

export const getUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutationFetcher = (
    params?: UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostParams,
    options?: SecondParameter<typeof uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutator>,
) => {
    return (_: Key, { arg }: { arg: BodyUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost }) => {
        return uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost(arg, params, options);
    };
};
export const getUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutationKey = (
    params?: UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostParams,
) => [`/documents/measurement-reports/upload/bundle`, ...(params ? [params] : [])] as const;

export type UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutationResult = NonNullable<
    Awaited<ReturnType<typeof uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost>>
>;
export type UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutationError = HTTPValidationError;

/**
 * @summary Upload a ZIP bundle of frequency measurement report PDFs
 */
export const useUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost = <
    TError = HTTPValidationError,
>(
    params?: UploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost>>,
            TError,
            Key,
            BodyUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost,
            Awaited<ReturnType<typeof uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePost>>
        > & { swrKey?: string };
        request?: SecondParameter<
            typeof uploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutator
        >;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey =
        swrOptions?.swrKey ??
        getUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutationKey(params);
    const swrFn = getUploadMeasurementReportBundleDocumentsMeasurementReportsUploadBundlePostMutationFetcher(
        params,
        requestOptions,
    );

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};
